import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ParcelCardView from '../components/ParcelCardView'
import {
  outsideOverageArea,
  showOutsideOverageAreaToast,
} from '../components/toast/outside-overage-area-toast'
import { useQueryFilterStore } from '../components/query-filter-modal/query-filter-store'
import AdvanceFilters from '../components/advance-filters/advance-filters'
import {
  Layer,
  Map,
  MapProvider,
  Marker,
  Popup,
  Source,
} from 'react-map-gl/maplibre'
import useMapStore from '../hooks/use-map-store'

import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

import ParcelDetail from '../components/ParcelDetail'
import LayerControlGroup from '../components/LayerControlGroup'
import { useAuth } from '../hooks/getAuth'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import ExtendDrawBar from '../components/ExtendDrawBar'
import Spinner from '../components/Spinner'
import { mapboxGLDrawRectangleDrag } from '../components/MapboxGLDrawRectangleDrag'
import martinVectorTileLayers from '../hooks/martinVectorTileLayers'
import * as turf from '@turf/turf'
import { callAPI } from '../hooks/api'
import apnLayers from '../hooks/apnLayers'
import Collapsible from 'react-collapsible'
import { cn } from '@/lib/utils'

import maplibregl from 'maplibre-gl'
import { toast } from 'react-toastify'
import MaplibreGeocoder from '@maplibre/maplibre-gl-geocoder'
import '@maplibre/maplibre-gl-geocoder/dist/maplibre-gl-geocoder.css'
import 'react-dropdown/style.css'
import legendImage from '../assets/svg/new legend.webp'

import SampleGeoJson from '../data/sample.json'

import '../index.css'
import '../assets/css/styles.css'
import { getBboxFromGeoJson, undefinedToZero } from '../hooks/utils'
import ranchApnLayers from '../hooks/ranchApnLayers'
import RanchSelectModal from '../components/RanchSelectModal'

import allRanchParcels from '../hooks/allRanchParcels'
import { browserName, isMobile } from 'react-device-detect'
import MobileParcelDetail from '../components/MobileParcelDetail'
import BrowserCheck from '../components/BrowserCheck'
import { createConfirmation } from 'react-confirm'
import ParcelCount from '../components/ParcelCount'
import CustomNavigationControl from '../components/CustomNavigationControl'
import InfoPopup from '../components/InfoPopup'
import { FaCircleInfo } from 'react-icons/fa6'
import initialApnLayers from '../hooks/initialApnLayers'
import InitialParcelCardView from '../components/InitialParcelCardView'
import RanchSelector from '../components/RanchSelector'
import ReleasePopup from '../components/ReleasePopup'
import useAbility from '@/hooks/use-ability'
import UpgradeLockIconLayout, {
  LockToolTipIcon,
} from '../components/upgrade-lock-icon-layout'
import QueryFilterModel from '../components/query-filter-modal/query-filter-modal'
import ApnSearchModal from '../components/apn-search-modal/apn-search-modal'
import { siteConfig } from '@/config/site'
import { useQueryState } from 'nuqs'
import { USER_FREE_TRAIL_STATUS_QUERY_KEY } from '@/components/welcome-modal/welcome-modal'
import TrialModal from '@/components/trial-modal/trial-modal'
import { ETierKey } from '@/pages/subscribe/_data/subscribe-constant'
import { TRIAL_LIMIT_QUERY_KEY } from '@/components/trial-modal/trial-limit-modal'
import { TRIAL_PLANS_QUERY_KEY } from '@/components/trial-modal/trial-plans-modal'
import { TrialLimitType } from '@/components/trial-modal/trial-limit-modal'
export default function Home({
  ranches,
  setRanches,
  parcels,
  setParcels,
  lnProperties,
  loopnetOriginalData,
  setLoopnetOriginalData,
  apnSource,
  apnLayer,
  apnOutlineLayer,
  apnLabelLayer,
  setApnSource,
  setApnLayer,
  setApnOutlineLayer,
  setApnLabelLayer,
  clearRanchSelection,
  ranchApnSource,
  ranchApnLayer,
  ranchApnOutlineLayer,
  ranchApnLabelLayer,
  setRanchApnSource,
  setRanchApnLayer,
  setRanchApnOutlineLayer,
  setRanchApnLabelLayer,
  freshRestart,
  selectedRanch,
  setSelectedRanch,
  ranchParcels,
  setRanchParcels,
  mapBounds,
  setMapBounds,
  mapRef,
  setCurrentTab,
  localAuth,
  firstLogin,
  setFirstLogin,
  joyrideRun,
  setJoyrideRun,
  initialParcels,
  setInitialParcels,
  initialApnSource,
  setInitialApnSource,
  initialApnLayer,
  setInitialApnLayer,
  initialApnOutlineLayer,
  setInitialApnOutlineLayer,
  clickedGeojson,
  setClickedGeojson,
}) {
  const removeStylesheet = (href) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')

  const isAac = localAuth.email?.includes('@agloan.com')
  const isYfc = localAuth.email?.includes('@yfc.ag')
  const isDemoUser =
    localAuth.sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
  const isFreeTrial = localAuth.tier === ETierKey.Trial

  const [_, setTrialLimitState] = useQueryState(TRIAL_LIMIT_QUERY_KEY)
  const [trialPlansState] = useQueryState(TRIAL_PLANS_QUERY_KEY)

  useEffect(() => {
    if (trialPlansState) {
      if (showModal) {
        setShowModal(false)
      }
    }
  }, [trialPlansState])

  useEffect(() => {
    const handleBackButton = () => {
      if (isDemoUser) {
        localStorage.setItem('auth', JSON.stringify({}))
        setAuth(null)
        setIsLoggedIn(false)
        setShowModal(false)
        deleteGeoJson()
        setApnLayer({})
        setApnOutlineLayer({})
        setApnLabelLayer({})
        setApnSource({})
        setRanchApnLayer({})
        setRanchApnOutlineLayer({})
        setRanchApnLabelLayer({})
        setRanchApnSource({})
        setMapBounds([[], []])
        setAoiVisibility({
          apn: false,
          sagbi: false,
          mls: false,
        })
        setShowParcelPopup(false)
        setShowPopup(false)
        setShowClickPopup(false)
        clearRanchSelection()
      }
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [isDemoUser])
  const { setAuth, isLoggedIn, setIsLoggedIn } = useAuth()
  const [releaseNotes, setReleaseNotes] = useState('')
  const [releaseDate, setReleaseDate] = useState('')
  const [releaseVersion, setReleaseVersion] = useState('')

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [mapLoaded, setMapLoaded] = useState(false)
  const [selectedProperty, setSelectedProperty] = useState({})
  const [mapWidthStyle, setMapWidthStyle] = useState(mapWidthStyleFunc())
  const [propertyWidthStyle, setPropertyWidthStyle] = useState(
    propertyWidthStyleFunc()
  )
  const [ranchesGeojson, setRanchesGeojson] = useState(null)

  const [initialRanch, setInitialRanch] = useState(0)

  const [initialParcelLayersData, setInitialParcelLayersData] = useState({})
  const [initialMarker, setInitialMarker] = useState(false)
  const [initialMarkerLat, setInitialMarkerLat] = useState(null)
  const [initialMarkerLon, setInitialMarkerLon] = useState(null)

  const [ranchParcelsSource, setRanchParcelsSource] = useState({})
  const [ranchParcelsLayer, setRanchParcelsLayer] = useState({})
  const [ranchParcelsOutlineLayer, setRanchParcelsOutlineLayer] = useState({})

  const [selectedParcelIds, setSelectedParcelIds] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showRanchSelectModal, setShowRanchSelectModal] = useState(false)

  const [popupContent, setPopupContent] = useState(null)

  const [searchParams] = useSearchParams()

  const [currentIndex, setCurrentIndex] = useState(-1)

  const confirm = createConfirmation(ParcelCount)

  const [baseMapVisibility, setBaseMapVisibility] = useState({
    Aerial: true,
    Dark: false,
    Light: false,
    Topo: false,
    Streets: false,
  })

  //   Hook ability
  const {
    checkAbility,
    isLoading: loadingAbility,
    invalidateQuery,
  } = useAbility()

  // State to manage modal visibility
  const [isQueryFilterModalOpen, setIsQueryFilterModalOpen] = useState(false)
  const [filterGeoJson, setFilterGeoJson] = useState({})

  //  Cleanup query filter when component unmount
  useEffect(() => {
    return () => {
      useQueryFilterStore.getState().resetForm()
    }
  }, [])

  const enableAPNDisplay = checkAbility('apn_display')
  const enablePropertyLines = checkAbility('property_lines') || isDemoUser
  const enableCustomRanches =
    checkAbility('custom_ranches_portfolio') || isDemoUser

  useEffect(() => {
    // Don't proceed if still loading abilities
    if (loadingAbility) return

    // Check user permissions
    const hasFilterCriteriaAccess = checkAbility('search_by_criteria')
    const hasApnSearchAccess = checkAbility('apn_search')
    const hasSelectByArea = checkAbility('property_lines')

    if (mapRef.current) {
      // Handle search icon
      const searchIcon = mapRef.current
        .getContainer()
        .querySelector('.search-apn-icon')

      if (searchIcon) {
        if (!hasApnSearchAccess && !isDemoUser) {
          searchIcon.classList.add('lock')
          searchIcon.title = 'Upgrade Plan'
          searchIcon.onclick = () => {
            navigate(siteConfig.upgradeUrl)
          }
        } else {
          searchIcon.onclick = () => apnSearch()
        }
      }

      // Handle filter criteria button
      const filterCriteriaButton = mapRef.current
        .getContainer()
        .querySelector('.mapboxgl-ctrl-query-button')

      if (filterCriteriaButton) {
        if (!hasFilterCriteriaAccess && !isDemoUser) {
          filterCriteriaButton.classList.add('lock')
          filterCriteriaButton.title = 'Upgrade Plan'
          filterCriteriaButton.onclick = () => {
            navigate(siteConfig.upgradeUrl)
          }
        } else {
          filterCriteriaButton.onclick = () => {
            if (isDemoUser) {
              toast.warn('This action is not available for demo users.')
              return
            }
            openModal()
          }
        }
      }

      const filterSelectByArea = mapRef.current
        .getContainer()
        .querySelector('.aoi-icon')

      if (filterSelectByArea) {
        if (!hasSelectByArea && !isDemoUser) {
          filterSelectByArea.classList.add('lock')
          filterSelectByArea.title = 'Upgrade Plan'
          filterSelectByArea.onclick = () => {
            navigate(siteConfig.upgradeUrl)
          }
        }
      }
    }
  }, [loadingAbility, checkAbility, mapRef, navigate, localAuth, mapLoaded])

  // Automatically cleans up and re-attaches listener when needed
  // Ensures event handler always has access to the latest value of enablePropertyLines
  useEffect(() => {
    if (!mapRef.current) return
    mapRef.current.off('click', defaultClickEvent)
    mapRef.current.off('contextmenu', defaultClickEvent)
    mapRef.current.off('dblclick', defaultClickEvent)

    mapRef.current.on('click', defaultClickEvent)
    mapRef.current.on('contextmenu', defaultClickEvent)
    mapRef.current.on('dblclick', defaultClickEvent)
    return () => {
      if (mapRef.current) {
        mapRef.current.off('click', defaultClickEvent)
        mapRef.current.off('contextmenu', defaultClickEvent)
        mapRef.current.off('dblclick', defaultClickEvent)
      }
    }
  }, [enablePropertyLines, mapRef.current])

  useEffect(() => {
    if (mapRef.current && searchParams.get('locations')) {
      try {
        const locations = JSON.parse(atob(searchParams.get('locations')))
        initialQueryApn('', '', 0, 0, false, false, locations)
      } catch (error) {}
    }
  }, [mapRef.current, searchParams])

  // Function to open the modal

  const openModal = () => {
    setIsQueryFilterModalOpen(true)
  }

  // Function to close the modal
  const closeModal = () => {
    setIsQueryFilterModalOpen(false)
  }

  var handleClose = () => setShowModal(false)
  var handleSuccess = () => {}

  const filterApnSourceById = (idToRemove) => {
    const updatedFeatures = apnSource.data.features.filter(
      (feature) => feature.id !== idToRemove
    )
    setApnSource((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        features: updatedFeatures,
      },
    }))
  }

  const filterRanchApnSourceById = (idToRemove) => {
    const updatedFeatures = ranchApnSource.data.features.filter(
      (feature) => feature.id !== idToRemove
    )
    setRanchApnSource((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        features: updatedFeatures,
      },
    }))
  }

  async function onParcelDelete(parcelId) {
    const proceed = await confirm({
      confirmation: `This action will remove the queried parcel from the list (querying it again will deduct from your quota). Do you want to proceed?`,
    })
    if (proceed) {
      const updateParcels = parcels.filter((parcel) => parcel.id !== parcelId)
      setMapBounds([[], []])
      setShowParcelPopup(false)
      setParcels(updateParcels)
      filterApnSourceById(parcelId)
      setVisibility({
        ...visibility,
        ['queried_parcels']: updateParcels.length > 0,
      })
    }
  }

  async function onParcelDeleteFromDetail(parcelId) {
    const updateParcels = parcels.filter((parcel) => parcel.id !== parcelId)
    setMapBounds([[], []])
    setShowParcelPopup(false)
    setParcels(updateParcels)
    filterApnSourceById(parcelId)
  }

  async function onParcelDeleteAll() {
    const allParcelIds = parcels.map((parcel) => parcel.id)
    if (allParcelIds.length === 0) return

    const proceed = await confirm({
      confirmation: `This action will remove all the parcels you’ve queried (querying them again will deduct from your quota). Do you want to continue?`,
    })
    if (proceed) {
      setMapBounds([[], []])
      setShowParcelPopup(false)
      setParcels([])
      setApnSource({})
      setVisibility({
        ...visibility,
        ['queried_parcels']: false,
      })
    }
  }

  function onRanchParcelDelete(parcelId, ranchId, parcelRefId) {
    var endpoint = '/delete_parcel_from_ranch'
    var params = {
      parcel_ref_id: parcelRefId,
      ranch_id: ranchId,
      session_key: localAuth.sessionKey,
    }
    setLoading(true)
    callAPI(endpoint, params)
      .then(async (res) => {
        setLoading(false)
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          return
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          logout()
          return
        } else {
          const updateParcels = ranchParcels.filter(
            (parcel) => parcel.id !== parcelId
          )
          updateParcels.sort((a, b) => {
            let apnA = a.data.apn || '' // Default to empty string if undefined
            let apnB = b.data.apn || ''
            return apnA.localeCompare(apnB)
          })
          setMapBounds([[], []])
          setShowParcelPopup(false)
          setShowModal(false)
          setRanchParcels(updateParcels)
          filterRanchApnSourceById(parcelId)

          var endpoint = '/get_portfolio_summary'
          var params = {
            ranch_id: ranchId.toString(),
            return_update: true,
            session_key: localAuth.sessionKey,
          }

          await callAPI(endpoint, params)
        }
      })
      .catch((e) => {
        toast.warn('Something went wrong. Please try again later.')
        console.log(e)
        setLoading(false)
      })
  }

  function getRanches(ranch_id = 0) {
    var endpoint = '/get_ranches'
    var params = {
      session_key: localAuth.sessionKey,
    }
    callAPI(endpoint, params).then((res) => {
      if (res.status === 'fail') {
        if (localAuth.tier !== ETierKey.Trial) toast.warn(res.msg)
        setLoading(false)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        setLoading(false)
        logout()
        return
      }
      getRanchesGeojson()
      setRanches(res.ranches.slice().sort((a, b) => b.ranch_id - a.ranch_id))
      if (ranch_id) {
        setSelectedRanch(
          res.ranches.find((ranch) => ranch.ranch_id == ranch_id)
        )
      }
    })
  }

  function getRanchesGeojson() {
    var endpoint = '/get_ranches_geojson'
    var params = {
      session_key: localAuth.sessionKey,
    }
    setRanchesGeojson(null)
    callAPI(endpoint, params).then((res) => {
      if (res.status === 'fail') {
        toast.warn(res.msg)
        setLoading(false)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        setLoading(false)
        logout()
        return
      }
      setRanchesGeojson(res.ranches_geojson)
    })
  }

  function onEdit(parcelId) {
    setShowRanchSelectModal(true)
    setSelectedParcelIds([parcelId])
  }

  function onEditAll(p = []) {
    if (p.length == 0) p = parcels

    const allParcelIds = p.map((parcel) => parcel.id)
    if (allParcelIds.length === 0) return
    setShowRanchSelectModal(true)
    setSelectedParcelIds(allParcelIds)
  }

  async function processInitialParceltoRanch(ranch_id, selectedElements) {
    return await Promise.all(
      selectedElements.map(async (selectedElement) => {
        return new Promise(async (resolve) => {
          // Extract and transform selectedElement properties
          const {
            properties: {
              parcel_id,
              owner,
              address,
              mail_address,
              county_name,
              mkt_val_land,
              mkt_val_bldg,
              hs,
              ss,
              latitude,
              longitude,
              gsa_info,
              wd_info,
              acreage_calc,
              crop_composition,
              sv,
              soil_composition,
              fld_zone,
              main_crop,
              hydrologic_info,
              acreage_deeded,
            },
            ...remainingFeature
          } = selectedElement

          // Prepare transformed feature with adjustments
          const transformedFeature = {
            ...remainingFeature,
            properties: {
              parcel_id,
              owner,
              address,
              mail_address,
              county_name,
              mkt_val_land,
              mkt_val_bldg,
              hs,
              ss,
              latitude,
              longitude,
              gsa_info,
              wd_info,
              acreage_calc,
              crop_composition,
              sv,
              soil_composition,
              fld_zone,
              main_crop,
              hydrologic_info,
              acreage_deeded,
            },
          }

          // Handle specific transformations
          transformedFeature.properties['mkt_val_land'] = undefinedToZero(
            transformedFeature.properties['mkt_val_land']
          )
          transformedFeature.properties['mkt_val_bldg'] = undefinedToZero(
            transformedFeature.properties['mkt_val_bldg']
          )

          if ('sv' in transformedFeature.properties) {
            const base64Image = btoa(transformedFeature.properties['sv'])
            transformedFeature.properties['sv'] =
              `data:image/png;base64,${base64Image}`
          }

          transformedFeature.properties['soil_properties'] = [['', '']]

          resolve(transformedFeature)

          // // Define API calls as promises
          // const apiCalls = [
          //   callAPI('/get_soils_props_pt', {
          //     lat: selectedElement.properties.latitude,
          //     lon: selectedElement.properties.longitude,
          //     session_key: localAuth.sessionKey,
          //   }),
          // ]

          // // Execute API calls concurrently
          // try {
          //   const [res2] = await Promise.all(apiCalls)

          //   // Handle response from second API call
          //   if (res2.status === 'success') {
          //     const splitSoilProperties = res2.soil.map((soilType) => {
          //       const [name, valueWithUnit] = soilType.split(/:(.+)/)

          //       const nameTrimmed = name.trim()
          //       const valueWithUnitTrimmed = valueWithUnit.trim()

          //       const match = nameTrimmed.match(/\[([^\]]+)\]/)
          //       const unit = match ? match[1] : ''

          //       const firstPart = nameTrimmed.replace(` [${unit}]`, '')
          //       const secondPart =
          //         valueWithUnitTrimmed + (unit ? ' ' + unit : '')

          //       return [firstPart, secondPart]
          //     })
          //     transformedFeature.properties['soil_properties'] =
          //       splitSoilProperties
          //   } else {
          //     transformedFeature.properties['soil_properties'] = [['', '']]
          //   }

          //   // Resolve transformed feature once all processing is done
          //   resolve(transformedFeature)
          // } catch (e) {
          //   setLoading(false)
          //   console.error(e)
          //   resolve() // Skip further processing on error
          // }
        })
      })
    ).then(async (transformedFeatures) => {
      // Execute API calls for adding parcels to ranch
      const apiCalls = transformedFeatures.map((transformedFeature) => {
        const endpoint = '/add_parcel_to_ranch'
        const params = {
          geojson_str: JSON.stringify(transformedFeature),
          ranch_id: ranch_id, // Use ranch_id directly
          session_key: localAuth.sessionKey,
        }

        // Return a promise for each API call
        return new Promise((resolve, reject) => {
          callAPI(endpoint, params)
            .then((existingParcels) => {
              resolve(existingParcels) // Resolve with API response
            })
            .catch((e) => {
              console.error(e)
              reject(e) // Propagate error
            })
        })
      })

      const res = await Promise.all(apiCalls)

      // Handle responses from all API calls
      res.forEach((item) => {
        if (item.status === 'fail') {
          toast.warn(item.msg)
        }
      })

      // Example additional API call after completing all ranch operations
      const endpoint = '/get_portfolio_summary'
      const params = {
        ranch_id: ranch_id.toString(), // Use ranch_id directly
        return_update: true,
        session_key: localAuth.sessionKey,
      }

      return callAPI(endpoint, params)
        .then((res) => {
          // Handle portfolio summary response
        })
        .catch((error) => {
          console.error(error)
        })
    })
  }

  function addInitialParcelToRanch(ranch, all = false) {
    setLoading(true)
    const geojson = all
      ? initialApnSource.data.features
      : clickedGeojson.features
    const endpoint = '/add_initial_parcel_to_ranch'
    var params = {
      geojson_str: JSON.stringify(geojson),
      session_key: localAuth.sessionKey,
    }
    if (ranch.ranch_id) params['ranch_id'] = ranch.ranch_id
    else params['ranch_name'] = ranch.ranch_name

    callAPI(endpoint, params).then((res) => {
      if (res.status === 'success') {
        processInitialParceltoRanch(res.ranch_id, res.dataframe.features).then(
          (res2) => {
            setShowRanchSelectModal(false)
            removeInitialParcels(
              geojson.map((feature) => feature.properties.parcel_id)
            )
            getRanches(res.ranch_id)
            // drawParcelsByRanchId(res.ranch_id)
            setLoading(false)
          }
        )
        if (!ranch.ranch_id) {
          invalidateQuery()
          setRanchName('')
        }
      } else {
        setLoading(false)
        toast.warn(res.msg)
      }
    })
  }

  function addParcelToRanch(ranch) {
    if (!Object.keys(ranch).length) {
      toast.warn('You must select ranch first.')
      return
    } else if (!selectedParcelIds.length) {
      toast.warn('You must select parcel(s) first.')
      return
    }
    setLoading(true)

    const selectedElements = parcels.filter((parcel) =>
      selectedParcelIds.includes(parcel.id)
    )

    const promises = selectedElements.map((selectedElement) => {
      return new Promise((resolve) => {
        const {
          properties: {
            parcel_id,
            owner,
            address,
            mail_address,
            county_name,
            mkt_val_land,
            mkt_val_bldg,
            hs,
            ss,
            latitude,
            longitude,
            gsa_info,
            wd_info,
            acreage_calc,
            crop_composition,
            sv,
            soil_composition,
            fld_zone,
            main_crop,
            hydrologic_info,
            acreage_deeded,
          },
          ...remainingFeature
        } = selectedElement.feature

        const transformedFeature = {
          ...remainingFeature,
          properties: {
            parcel_id,
            owner,
            address,
            mail_address,
            county_name,
            mkt_val_land,
            mkt_val_bldg,
            hs,
            ss,
            latitude,
            longitude,
            gsa_info,
            wd_info,
            acreage_calc,
            crop_composition,
            sv,
            soil_composition,
            fld_zone,
            main_crop,
            hydrologic_info,
            acreage_deeded,
          },
        }
        transformedFeature.properties['mkt_val_land'] = undefinedToZero(
          transformedFeature.properties['mkt_val_land']
        )
        transformedFeature.properties['mkt_val_bldg'] = undefinedToZero(
          transformedFeature.properties['mkt_val_bldg']
        )

        if ('sv' in transformedFeature.properties) {
          const base64Image = btoa(transformedFeature.properties['sv'])
          transformedFeature.properties['sv'] =
            `data:image/png;base64,${base64Image}`
        }

        transformedFeature.properties['soil_properties'] = [['', '']]
        resolve(transformedFeature)
        // const apiCalls = [
        //   callAPI('/get_soils_props_pt', {
        //     lat: selectedElement.data.geolocation.lat,
        //     lon: selectedElement.data.geolocation.lng,
        //     session_key: localAuth.sessionKey,
        //   }),
        // ]

        // Promise.all(apiCalls)
        //   .then(([res]) => {
        //     if (res.status === 'success') {
        //       const splitSoilProperties = res.soil.map((soilType) => {
        //         const [name, valueWithUnit] = soilType.split(/:(.+)/)

        //         // Trim to remove leading/trailing whitespaces
        //         const nameTrimmed = name.trim()
        //         const valueWithUnitTrimmed = valueWithUnit.trim()

        //         // Extract unit from the first part of the string
        //         const match = nameTrimmed.match(/\[([^\]]+)\]/)
        //         const unit = match ? match[1] : ''

        //         // Combine the parts with the unit
        //         const firstPart = nameTrimmed.replace(` [${unit}]`, '')
        //         const secondPart =
        //           valueWithUnitTrimmed + (unit ? ' ' + unit : '')

        //         return [firstPart, secondPart]
        //       })
        //       transformedFeature.properties['soil_properties'] =
        //         splitSoilProperties
        //     } else {
        //       transformedFeature.properties['soil_properties'] = [['', '']]
        //     }

        //     resolve(transformedFeature)
        //   })
        //   .catch((e) => {
        //     setLoading(false)
        //     console.log(e)
        //     resolve() // Skip further processing on error
        //   })
      })
    })

    Promise.all(promises)
      .then((transformedFeatures) => {
        setLoading(false)
        const apiCalls = transformedFeatures.map((transformedFeature) => {
          const endpoint = '/add_parcel_to_ranch'
          const params = {
            geojson_str: JSON.stringify(transformedFeature),
            ranch_id: ranch.ranch_id,
            session_key: localAuth.sessionKey,
          }

          // Return a promise for each API call
          return new Promise((resolve, reject) => {
            callAPI(endpoint, params)
              .then((existingParcels) => {
                // Handle the response as needed
                resolve(existingParcels)
              })
              .catch((e) => {
                // Handle errors
                console.log(e)
                reject(e)
              })
          })
        })

        Promise.all(apiCalls)
          .then(async (res) => {
            res.map((item, index) => {
              if (item.status === 'fail') toast.warn(item.msg)
            })
            var endpoint = '/get_portfolio_summary'
            var params = {
              ranch_id: ranch.ranch_id.toString(),
              return_update: true,
              session_key: localAuth.sessionKey,
            }

            await callAPI(endpoint, params)
            setLoading(false)

            getRanchesGeojson()

            deleteGeoJson()
            setShowRanchSelectModal(false)
            setSelectedRanch(ranch)
            drawParcelsByRanchId(ranch.ranch_id)

            const updateParcels = parcels.filter(
              (parcel) => !selectedParcelIds.includes(parcel.id)
            )
            setMapBounds([[], []])
            setShowParcelPopup(false)
            setParcels(updateParcels)

            const updatedFeatures = apnSource.data.features.filter(
              (feature) => !selectedParcelIds.includes(feature.id)
            )
            setApnSource((prevState) => ({
              ...prevState,
              data: {
                ...prevState.data,
                features: updatedFeatures,
              },
            }))
          })
          .catch((error) => {
            // Handle errors if any of the API calls fail
            console.error(error)
          })
      })
      .catch((error) => {
        console.error(error)
      })
  }

  function logout() {
    // TODO : signOut
    localStorage.setItem('auth', JSON.stringify({}))
    setAuth(null)
    setIsLoggedIn(false)
    setShowModal(false)
    deleteGeoJson()
    setApnLayer({})
    setApnOutlineLayer({})
    setApnLabelLayer({})
    setApnSource({})
    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})
    setMapBounds([[], []])
    setAoiVisibility({
      apn: false,
      sagbi: false,
      mls: false,
    })
    setShowParcelPopup(false)
    setShowPopup(false)
    setShowClickPopup(false)
    clearRanchSelection()
    navigate(
      '/' +
        (searchParams.get('locations')
          ? '?locations=' + searchParams.get('locations')
          : '')
    )
  }

  function mapWidthStyleFunc() {
    return { width: '100vw', height: '100vh' }
  }

  function propertyWidthStyleFunc() {
    if (window.innerWidth < 690) {
      return {
        minHeight: '10px',
        maxHeight: '70vh',
        width: '100vw',
        height: '160px',
      }
    } else if (window.innerWidth < 768) {
      return {
        minWidth: '35vw',
        width: '35vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else if (window.innerWidth < 1024) {
      return {
        minWidth: '30vw',
        width: '30vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else if (window.innerWidth < 1280) {
      return {
        minWidth: '25vw',
        width: '25vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else {
      return {
        minWidth: '25vw',
        width: '25vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    }
  }

  function onPropertyClicked(property) {
    setShowModal(true)

    setSelectedProperty(property)
  }

  function handleInitialParcelOut() {
    if (Object.keys(initialApnSource).length) {
      const updatedFeatures = initialApnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedInitialApnSource = {
        ...initialApnSource,
        data: {
          ...initialApnSource.data,
          features: updatedFeatures,
        },
      }
      setInitialApnSource(updatedInitialApnSource)
    }
  }

  function handleInitialParcelSelection(parcel) {
    handleInitialParcelOut()

    if (initialApnSource) {
      const updatedFeatures = initialApnSource.data.features.map((feature) => {
        if (
          feature.properties.parcel_id == parcel.feature.properties.parcel_id
        ) {
          setInitialMarker(true)
          setInitialMarkerLat(parcel.feature.properties.latitude)
          setInitialMarkerLon(parcel.feature.properties.longitude)

          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#79ff00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })

      const updatedInitialApnSource = {
        ...initialApnSource,
        data: {
          ...initialApnSource.data,
          features: updatedFeatures,
        },
      }

      setInitialApnSource(updatedInitialApnSource)

      // Extract map bounds and parcel bounds
      const mapBounds = mapRef.current.getBounds()
      const [mapSw, mapNe] = [
        mapBounds.getSouthWest(),
        mapBounds.getNorthEast(),
      ]
      const [parcelMinLng, parcelMinLat, parcelMaxLng, parcelMaxLat] =
        parcel.feature.bbox

      // Check if parcelBounds are within mapBounds
      const isWithinBounds =
        parcelMinLat >= mapSw.lat &&
        parcelMaxLat <= mapNe.lat &&
        parcelMinLng >= mapSw.lng &&
        parcelMaxLng <= mapNe.lng
      // Helper function to get bounding box
      const getBoundingBox = (coordinates) => {
        const minLat = Math.min(...coordinates.map((coord) => coord[1]))
        const maxLat = Math.max(...coordinates.map((coord) => coord[1]))
        const minLon = Math.min(...coordinates.map((coord) => coord[0]))
        const maxLon = Math.max(...coordinates.map((coord) => coord[0]))

        return [
          [minLon, minLat],
          [maxLon, maxLat],
        ]
      }
      if (!isWithinBounds) {
        // Create new bounds that include both mapBounds and parcelBounds
        const newBounds = getBoundingBox([
          [parcelMinLng, parcelMinLat],
          [parcelMaxLng, parcelMaxLat],
          [mapSw.lng, mapSw.lat],
          [mapNe.lng, mapNe.lat],
        ])

        // Update map bounds
        mapRef.current.fitBounds(newBounds, { padding: 50 })
      }
    }
  }

  function handlePropertyMouseOut(parcel) {
    if (Object.keys(apnSource).length) {
      const updatedFeatures = apnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedApnSource = {
        ...apnSource,
        data: {
          ...apnSource.data,
          features: updatedFeatures,
        },
      }
      setApnSource(updatedApnSource)
    }
    if (loopnetOriginalData.length) {
      const updatedData = loopnetOriginalData.map((item) => ({
        ...item,
        color: 'red',
      }))
      setLoopnetOriginalData(updatedData)
    }
    if (Object.keys(ranchApnSource).length) {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }
      setRanchApnSource(updatedRanchApnSource)
    }
  }

  function handlePropertyMouseOver(parcel) {
    handlePropertyMouseOut()
    if (apnSource && parcel.type === 'aoi') {
      const updatedFeatures = apnSource.data.features.map((feature) => {
        if (feature.id == parcel.id) {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#FFFF00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })
      const updatedApnSource = {
        ...apnSource,
        data: {
          ...apnSource.data,
          features: updatedFeatures,
        },
      }

      setApnSource(updatedApnSource)
    }
    if (ranchApnSource && parcel.type === 'ranch') {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        if (feature.id == parcel.id) {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#FFFF00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })
      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }

      setRanchApnSource(updatedRanchApnSource)
    }
    if (loopnetOriginalData && parcel.type === 'ln') {
      const updatedData = loopnetOriginalData.map((item) =>
        item.id == parcel.id ? { ...item, color: 'yellow' } : item
      )
      setLoopnetOriginalData(updatedData)
    }
  }

  function handleResize() {
    setMapWidthStyle(mapWidthStyleFunc())
    setPropertyWidthStyle(propertyWidthStyleFunc())
  }

  useEffect(() => {
    if (isDemoUser) {
      freshRestart()
      setAoiVisibility({
        apn: false,
        sagbi: false,
        mls: false,
      })
      setShowParcelPopup(false)
      setShowPopup(false)
      setShowClickPopup(false)
    }
    if (localAuth.status === 'no sub') {
      navigate('/subscribe')
      return
    }
    if (Object.keys(localAuth).length) {
      callAPI('/get_is_subscribed', { session_key: localAuth.sessionKey }).then(
        (res) => {
          if (res.status === 'expire') {
            toast.warn(res.msg)
          } else if (!res.is_subscribed) {
            toast.warn(
              'Your subscription is pending. If you have just subscribed or updated your subscription, please allow 1–3 minutes for processing. If the issue persists, please contact info@hydrascore.com.'
            )
          } else {
            setCurrentTab('home')
            getRanches()
            window.addEventListener('resize', handleResize)
            return () => {
              window.removeEventListener('resize', handleResize)
            }
          }
        }
      )
    }
  }, [])

  function undefinedToEmpty(str) {
    if (typeof str === 'undefined') {
      return ''
    } else {
      if (str === 'white_area') return 'White Area'
      else if (str === 'rated') return 'Rated'
      else if (str === 'unrated') return 'Unrated'
      return str
    }
  }

  const [baseMapSourceStyles, setBaseMapSourceStyles] = useState({})
  const [baseMapLayerStyles, setBaseMapLayerStyles] = useState({})
  const [layerList, setLayerList] = useState([])
  const [dragAcres, setDragAcres] = useState(0)
  const popupRef = useRef(null)

  const MODES = MapboxDraw.modes

  MODES.draw_rectangle = mapboxGLDrawRectangleDrag(setDragAcres)
  const draw = new MapboxDraw({
    displayControlsDefault: false,
    modes: MODES,
  })

  var BASE_URL =
    document.location.protocol + '//' + document.location.hostname + ':4011'
  if (process.env.REACT_APP_ENV === 'staging')
    BASE_URL = 'https://staging-api.hydrascore.com'
  else if (process.env.REACT_APP_ENV === 'dev')
    BASE_URL = 'https://dev-api.hydrascore.com'
  else if (process.env.NODE_ENV === 'production')
    BASE_URL = 'https://api.hydrascore.com'
  const Geo = {
    // required
    forwardGeocode: async (config) => {
      try {
        const query = config.query
        const response = await fetch(
          BASE_URL + `/autocomplete?input=${encodeURIComponent(query)}`
        )

        if (!response.ok) {
          throw new Error(
            `Failed to fetch suggestions, status ${response.status}`
          )
        }

        const data = await response.json()

        // Ensure predictions array exists and is not empty
        if (data.length === 0) {
          throw new Error('No predictions found')
        }
        return { features: [data[0]] } // Return suggestions array wrapped in an object
      } catch (error) {
        console.error('Error in getSuggestions:', error)
        throw error // Rethrow the error to propagate it further
      }
    },

    // optional
    reverseGeocode: async (config) => {
      const { lat, lon } = config.query
      const limit = config.limit || 5
      const response = await fetch(
        BASE_URL + `/reverse_geocode?lat=${lat}&lon=${lon}`
      )
      const data = await response.json()

      const features = data.results.slice(0, limit).map((result) => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              result.geometry.location.lng,
              result.geometry.location.lat,
            ],
          },
          properties: {
            name: result.formatted_address,
            place_id: result.place_id,
          },
        }
      })

      return { features: features }
    },
    // optional
    getSuggestions: async (config) => {
      try {
        const query = config.query
        const response = await fetch(
          BASE_URL + `/autocomplete?input=${encodeURIComponent(query)}`
        )

        if (!response.ok) {
          throw new Error(
            `Failed to fetch suggestions, status ${response.status}`
          )
        }

        const data = await response.json()

        return { features: data }
      } catch (error) {
        console.error('Error in getSuggestions:', error)
        throw error // Rethrow the error to propagate it further
      }
    },

    // optional
    searchByPlaceId: async (config) => {
      const placeId = config.query.place_id
      const response = await fetch(
        BASE_URL + `/place_details?place_id=${placeId}`
      )
      const data = await response.json()

      const result = data.result
      const feature = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            result.geometry.location.lng,
            result.geometry.location.lat,
          ],
        },
        properties: {
          name: result.formatted_address,
          place_id: result.place_id,
        },
      }

      return { features: [feature] }
    },
  }

  const options = {
    marker: true,
    popup: true,
    showResultsWhileTyping: true,
    minLength: 4,
    flyTo: {
      padding: 15, // If you want some minimum space around your result
      easing: function (t) {
        return t
      },
      maxZoom: 15,
    },
  }

  const geocoder = new MaplibreGeocoder(Geo, {
    maplibregl: maplibregl,
    ...options,
  })

  const [isSearchOn, setIsSearchOn] = useState({
    rect: false,
    apn: false,
  })

  const [isLayerOn, setIsLayerOn] = useState(false)

  const drawRectangle = () => {
    if (isDemoUser) {
      toast.warn('This action is not available for demo users.')
      return
    }
    setShowParcelPopup(false)
    if (draw.getMode() === 'draw_rectangle') draw?.changeMode('simple_select')
    else draw?.changeMode('draw_rectangle')
    setIsSearchOn((prevState) => ({
      ['rect']: draw.getMode() === 'draw_rectangle',
    }))
  }
  const apnSearch = () => {
    if (isDemoUser) {
      toast.warn('This action is not available for demo users.')
      return
    }
    setShowParcelPopup(false)
    setIsSearchOn((prevState) => ({
      ...prevState,
      ['apn']: true,
    }))
  }
  const toggleLayers = () => {
    setIsLayerOn((prevState) => !prevState)
    const layersCloseElement = document.querySelector('.layers-close-icon')
    const layersElement = document.querySelector('.layers-icon')

    if (layersElement) {
      layersElement.className = 'layers-close-icon'
      layersElement.title = 'Hide Layers'
    }
    if (layersCloseElement) {
      layersCloseElement.className = 'layers-icon'
      layersCloseElement.title = 'Show Layers'
    }
  }
  function addRectSearchEvent(e) {
    if (isSearchOn.rect) {
      setIsSearchOn((prevState) => ({
        ...prevState,
        ['rect']: !isSearchOn.rect,
      }))
      mapRef.current.off('mouseup', addRectSearchEvent)
    }
  }

  function removeInitialParcels(parcelIds) {
    const map = mapRef.current
    const sources = map.getStyle().sources
    const prevSource = sources['initial_APN_source']
    const geojson = prevSource.data
    setInitialParcels((prevParcels) => {
      // Return a new array excluding the parcel with the matching parcelId
      return prevParcels.filter(
        (parcel) => !parcelIds.includes(parcel.feature.properties.parcel_id)
      )
    })
    // Filter the features array
    const filteredFeatures = geojson.features.filter((feature) => {
      return !parcelIds.includes(feature.properties.parcel_id)
    })

    // Create a new GeoJSON object with the filtered features
    const updatedPrevGeojson = {
      ...prevSource.data, // Keep all the existing properties of prevSource.data
      features: filteredFeatures, // Replace the features array with the filtered one
    }
    var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
      initialApnLayers(updatedPrevGeojson)

    setInitialApnSource(initialApnSource)
    setInitialApnLayer(initialApnLayer)
    setInitialApnOutlineLayer(initialApnOutlineLayer)
    setInitialMarker(false)
    setShowInitialRightClickPopup(false)
  }
  let clickTimeout
  let isDoubleClick = false

  const setInitialParcelLayersDataByPoint = async (map, point) => {
    const sources = map.getStyle().sources
    const layerName = {
      sgma_county: 'County',
      hydra_gsa: 'GSA',
      hydra_wd_vw: 'Water Districts',
      provisional_crops_2023: 'Statewide Crops',
    }
    const currentLayers = Object.keys(sources)
      .filter((key) => layerName.hasOwnProperty(key)) // Check if key exists in json
      .map((key) => layerName[key]) // Get the corresponding value

    if (currentLayers.length > 0) {
      const features = map.queryRenderedFeatures(point, {
        layers: currentLayers, // Specify the vector layer to query
      })
      var layersData = {}
      features.map((feature) => {
        if (feature.source === 'sgma_county')
          layersData['County Name'] = feature.properties.namelsad
        else if (feature.source === 'hydra_gsa') {
          if (layersData['GSA'])
            layersData['GSA'] =
              layersData['GSA'] + ', ' + feature.properties.gsa_name
          else layersData['GSA'] = feature.properties.gsa_name
        } else if (feature.source === 'hydra_wd_vw') {
          if (layersData['Water District'])
            layersData['Water District'] =
              layersData['Water District'] +
              ', ' +
              feature.properties.agencyname
          else layersData['Water District'] = feature.properties.agencyname
        }
        // } else if(feature.source === "provisional_crops_2023") layersData["Main Crop"] = feature.properties.main_crop
      })
      setInitialParcelLayersData(layersData)
    } else {
      setInitialParcelLayersData({})
    }
  }

  async function defaultClickEvent(e) {
    const ctrlKeyPressed = e.originalEvent.ctrlKey
    const coordinates = e.lngLat
    const map = mapRef.current

    const sources = map.getStyle().sources
    const layerName = {
      sgma_ewrims: 'Water Rights (eWRIMS)',
      rated_wd_mat_vw: 'Rated Regions - Water Districts',
      rated_gsa_mat_vw: 'Rated Regions - GSAs',
      ca_grape_pricing_districts: 'Grape Pricing Districts',
      yfc_territory: 'YFC Territory',
    }
    const currentLayers = Object.keys(sources)
      .filter((key) => layerName.hasOwnProperty(key)) // Check if key exists in json
      .map((key) => layerName[key]) // Get the corresponding value

    const features = map.queryRenderedFeatures(e.point, {
      layers: currentLayers, // Specify the vector layer to query
    })
    if (
      features.filter(
        (feature) =>
          feature.source === 'sgma_ewrims' ||
          feature.source === 'rated_wd_mat_vw' ||
          feature.source === 'rated_gsa_mat_vw' ||
          feature.source === 'ca_grape_pricing_districts'
      ).length > 0
    )
      return

    setInitialParcelLayersDataByPoint(map, e.point)

    const apnSource = sources['APN_source']
    const ranchApnSource = sources['Ranch_APN_source']
    const prevSource = sources['initial_APN_source']
    const filterSource = sources['filter-source']

    if (showInitialRightClickPopup) {
      setShowInitialRightClickPopup(false)
      return
    }

    // Do nothing if clicked on queried parcel
    if (apnSource || ranchApnSource) {
      // Get features from both sources
      const apnFeatures = apnSource ? apnSource.data.features : []
      const ranchApnFeatures = ranchApnSource
        ? ranchApnSource.data.features
        : []

      const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

      // Check if clicked point is within any feature in apnSource
      const clickedApnFeatures = apnFeatures.filter((feature) =>
        turf.booleanPointInPolygon(clickedPoint, feature)
      )

      // Check if clicked point is within any feature in ranchApnSource
      const clickedRanchApnFeatures = ranchApnFeatures.filter((feature) =>
        turf.booleanPointInPolygon(clickedPoint, feature)
      )

      // If clicked point is in apnSource and NOT in ranchApnSource
      if (clickedApnFeatures.length > 0 || clickedRanchApnFeatures.length > 0) {
        if (
          e.type === 'click' ||
          e.type === 'touchend' ||
          e.type === 'dblclick'
        ) {
          return // Do nothing
        } else if (e.type === 'contextmenu' && clickedApnFeatures.length > 0) {
          // Show context menu popup
          setShowRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedApnFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setInitialMarker(false)
          return
        } else if (
          e.type === 'contextmenu' &&
          clickedRanchApnFeatures.length > 0
        ) {
          // Show context menu popup
          setShowRanchRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedRanchApnFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRightClickPopup(false)
          setInitialMarker(false)
          return
        }
      }
    }

    // Remove clicked parcel
    if (prevSource) {
      if (e.type === 'click' || e.type === 'touchend') {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          const parcelId = clickedFeatures[0].properties.parcel_id
          removeInitialParcels([parcelId])
          return
        }
      } else if (e.type === 'contextmenu') {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          const parcelId = clickedFeatures[0].properties.parcel_id
          // Add the Parcel ID and the list items
          setShowInitialRightClickPopup(true)
          setShowRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)

          let aoi_parcels = []
          // Process the new parcels
          geojson.features.map(async (feature, index) => {
            let imgUrls = []
            if (feature.properties['parcel_id'] === parcelId) {
              // Update the feature's latitude and longitude in geojson.features
              geojson.features[index].properties.latitude =
                e.lngLat.lat.toFixed(5)
              geojson.features[index].properties.longitude =
                e.lngLat.lng.toFixed(5)
            }
            aoi_parcels.push({
              type: 'aoi',
              id: feature.id,
              data: {
                name:
                  'owner' in feature.properties
                    ? feature.properties['owner']
                    : 'Area of Interest',
                imgUrls: imgUrls,
                address:
                  'mail_address' in feature.properties
                    ? feature.properties['mail_address']
                    : 'N/A',
                county:
                  'county_name' in feature.properties
                    ? feature.properties['county_name']
                    : null,
                apn:
                  'parcel_id' in feature.properties
                    ? feature.properties['parcel_id']
                    : 'N/A',
                // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
                geolocation: {
                  lat: feature.properties['latitude'],
                  lng: feature.properties['longitude'],
                },
              },
              feature: feature,
            })
          })

          // Update the state with the new parcels
          setInitialParcels(aoi_parcels)

          let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
            initialApnLayers(geojson)

          setInitialApnSource(initialApnSource)
          setInitialApnLayer(initialApnLayer)
          setInitialApnOutlineLayer(initialApnOutlineLayer)
          setClickedGeojson({
            type: 'FeatureCollection',
            features: clickedFeatures,
          })
          setRightClickParcelId(clickedFeatures[0].properties.parcel_id)
          setInitialMarker(true)
          setInitialMarkerLat(coordinates.lat)
          setInitialMarkerLon(coordinates.lng)
          return
        }
      }
    }
    if (filterSource) {
      if (e.type === 'click' || e.type === 'touchend') {
        const geojson = filterSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          e.preventDefault()
          setInitialMarker(false)
          setShowRightClickPopup(false)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          let aoi_parcels = []

          let mergedGeojson = {
            type: 'FeatureCollection',
            features: clickedFeatures,
            bbox: clickedFeatures[0].bbox,
          }

          if (ctrlKeyPressed && prevSource) {
            mergedGeojson = {
              ...prevSource.data,
              features: [...prevSource.data.features, ...clickedFeatures],
            }
          }
          // Process the new parcels
          mergedGeojson.features.map(async (feature, index) => {
            let imgUrls = []
            // if ('sv' in feature.properties) {
            //     const base64Image = btoa(feature.properties['sv']);
            //     imgUrls.push(`data:image/png;base64,${base64Image}`);
            // }
            aoi_parcels.push({
              type: 'aoi',
              id: feature.id,
              data: {
                name:
                  'owner' in feature.properties
                    ? feature.properties['owner']
                    : 'Area of Interest',
                imgUrls: imgUrls,
                address:
                  'mail_address' in feature.properties
                    ? feature.properties['mail_address']
                    : 'N/A',
                county:
                  'county_name' in feature.properties
                    ? feature.properties['county_name']
                    : null,
                apn:
                  'parcel_id' in feature.properties
                    ? feature.properties['parcel_id']
                    : 'N/A',
                // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
                geolocation: {
                  lat: e.lngLat.lat.toFixed(5),
                  lng: e.lngLat.lng.toFixed(5),
                },
              },
              feature: feature,
            })
          })

          // Update the state with the new parcels
          setInitialParcels(aoi_parcels)

          let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
            initialApnLayers(mergedGeojson)

          setInitialApnSource(initialApnSource)
          setInitialApnLayer(initialApnLayer)
          setInitialApnOutlineLayer(initialApnOutlineLayer)
          setClickedGeojson({
            type: 'FeatureCollection',
            features: clickedFeatures,
            bbox: clickedFeatures[0].bbox,
          })

          return
        }
      } else if (e.type === 'contextmenu') {
        const geojson = filterSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          // Show context menu popup
          setShowFilterRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setShowRightClickPopup(false)
          setInitialMarker(false)
          return
        }
      }
    }

    // Handle double-click event
    if (e.type === 'dblclick') {
      clearTimeout(clickTimeout) // Cancel any pending single-click
      isDoubleClick = true // Mark that a double-click happened
      if (!enablePropertyLines) return
      if (prevSource) {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          if (e.preventDefault && typeof e.preventDefault === 'function') {
            e.preventDefault()
          }
          setInitialMarker(false)
          setShowRightClickPopup(false)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          queryApn('', '', '', '', '', JSON.stringify(clickedFeatures), true)
          return
        }
      }
      if (e.preventDefault && typeof e.preventDefault === 'function') {
        e.preventDefault()
      }
      setInitialMarker(false)
      setShowRightClickPopup(false)
      setShowInitialRightClickPopup(false)
      setShowRanchRightClickPopup(false)
      queryApn('', '', e.lngLat.lat, e.lngLat.lng, '', '', ctrlKeyPressed)

      return
    }

    // Delay for single-click detection
    if (e.type === 'click' || e.type === 'touchend') {
      isDoubleClick = false // Reset the double-click flag
      if (!enablePropertyLines) return

      clickTimeout = setTimeout(async () => {
        if (!isDoubleClick) {
          setInitialMarker(true)
          setInitialMarkerLat(coordinates.lat)
          setInitialMarkerLon(coordinates.lng)
          initialQueryApn(
            '',
            '',
            coordinates.lat,
            coordinates.lng,
            ctrlKeyPressed,
            e.type === 'contextmenu'
          )
          return
        }
      }, 200) // Set the delay to 300ms (adjustable)
    }
  }

  const ranchId = searchParams.get('ranchId')
  const parcelId = searchParams.get('parcelId')

  useEffect(() => {
    if (ranchId && parcelId) {
      drawParcelsByRanchId(ranchId)
    }
  }, [ranchId, parcelId])

  useEffect(() => {
    if (ranchParcels.length > 0 && ranchId && parcelId) {
      const property = ranchParcels.filter((parcel) => parcel.id === parcelId)
      onPropertyClicked(property[0])
    }
  }, [JSON.stringify(ranchParcels)])

  useEffect(() => {
    if (clickedGeojson) {
      initialParcels.map(async (parcel, index) => {
        if (
          parcel.data.apn === clickedGeojson.features[0].properties.parcel_id
        ) {
          if (!mapRef.current) return
          const pointInView = await mapRef.current.project({
            lng: parcel.feature.properties.longitude,
            lat: parcel.feature.properties.latitude,
          })
          setInitialParcelLayersDataByPoint(mapRef.current, pointInView)
          setCurrentIndex(index)
          handleInitialParcelSelection(parcel)
        }
      })
    }
  }, [clickedGeojson])

  useEffect(() => {
    if (mapRef.current) {
      if (!isMobile) {
        if (isSearchOn.rect) {
          mapRef.current.getCanvas().style.cursor = 'crosshair'
          mapRef.current.on('mouseup', addRectSearchEvent)
        } else {
          mapRef.current.getCanvas().style.cursor = 'pointer'
        }
      }
    }
  }, [isSearchOn])

  useEffect(() => {
    if (
      mapRef.current &&
      Object.keys(apnSource).length > 0 &&
      Object.keys(apnLayer).length > 0 &&
      Object.keys(apnOutlineLayer).length > 0 &&
      Object.keys(apnLabelLayer).length > 0
    ) {
      setAoiVisibility({ ...aoiVisibility, ['apn']: true, ['mls']: true })
      mapRef.current.on('click', apnLayer.id, function (e) {
        parcels.forEach((parcel) => {
          if (parcel.id == e.features[0].id) {
            setPopupParcel(parcel)
          }
        })

        let coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
      mapRef.current.on('touchend', apnLayer.id, function (e) {
        parcels.forEach((parcel) => {
          if (parcel.id == e.features[0].id) {
            setPopupParcel(parcel)
          }
        })

        let coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
    }
  }, [mapRef.current, apnLayer, apnOutlineLayer, apnLabelLayer])

  useEffect(() => {
    if (
      mapRef.current &&
      Object.keys(ranchApnSource).length > 0 &&
      Object.keys(ranchApnLayer).length > 0 &&
      Object.keys(ranchApnOutlineLayer).length > 0 &&
      Object.keys(ranchApnLabelLayer).length > 0
    ) {
      setAoiVisibility({ ...aoiVisibility, ['apn']: true, ['mls']: true })
      mapRef.current.on('click', ranchApnLayer.id, function (e) {
        ranchParcels.forEach((ranchParcel) => {
          if (ranchParcel.id == e.features[0].id) {
            setPopupParcel(ranchParcel)
          }
        })

        let coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
      mapRef.current.on('touchend', ranchApnLayer.id, function (e) {
        ranchParcels.forEach((ranchParcel) => {
          if (ranchParcel.id == e.features[0].id) {
            setPopupParcel(ranchParcel)
          }
        })

        let coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
    }
  }, [mapRef.current, ranchApnLayer, ranchApnOutlineLayer, ranchApnLabelLayer])

  useEffect(() => {
    if (searchParams.get('locations')) {
      try {
        if (mapRef.current) {
          const locations = JSON.parse(atob(searchParams.get('locations')))
          mapRef.current.flyTo({
            center: [locations[0]['lon'], locations[0]['lat']],
            zoom: 14,
            essential: true,
          })
          return
        }
      } catch (error) {}
    }

    if (searchParams.get(USER_FREE_TRAIL_STATUS_QUERY_KEY)) {
      return
    }

    if (!firstLogin) {
      if (!joyrideRun) {
        if (mapRef.current && mapBounds[0].length === 0) {
          navigator.geolocation.getCurrentPosition((position) => {
            mapRef.current.flyTo({
              center: [position.coords.longitude, position.coords.latitude],
              zoom: 14,
              essential: true,
            })
          })
        }
        return
      }
      navigate('/tutorial')
      return
    }

    if (firstLogin === true) {
      let endpoint = '/get_release_notes'
      callAPI(endpoint, {}).then((res) => {
        setReleaseNotes(res.release_notes)
        setReleaseDate(res.release_date)
        setReleaseVersion(res.release_version)
      })
    }
  }, [joyrideRun, firstLogin, mapRef.current])

  useEffect(() => {
    if (!mapRef.current) {
      return
    }

    const getCurrentSources = async () => {
      const map = mapRef.current
      if (map) {
        const sources = map.getStyle().sources
        const prevSource = sources['initial_APN_source']
        if (prevSource) {
          const selectedFeature = prevSource.data.features.find(
            (feature) => feature.properties.selected
          )
          if (selectedFeature) {
            const pointInView = await map.project({
              lng: selectedFeature.properties.longitude,
              lat: selectedFeature.properties.latitude,
            })
            setInitialParcelLayersDataByPoint(map, pointInView)
          }
        }
      }
    }

    // Set up the event listener for when sources are updated
    mapRef.current.on('sourcedata', (e) => {
      if (e.isSourceLoaded) {
        const layerNames = [
          'sgma_county',
          'hydra_gsa',
          'hydra_wd_vw',
          'provisional_crops_2023',
        ]
        if (layerNames.includes(e.sourceId)) getCurrentSources()
      }
    })

    // Clean up the listener when the component unmounts
    return () => {
      if (mapRef.current) {
        mapRef.current.off('sourcedata', getCurrentSources)
      }
    }
  }, [mapRef.current])

  async function onDraw(e) {
    let endpoint = '/get_query_parcel_counts'
    let params = { bounds: turf.bbox(e.features[0].geometry) }
    callAPI(endpoint, params).then(async (res) => {
      if (res.status === 'fail') {
        toast.warn(res.msg)
        deleteGeoJson()
        return
      } else if (res.msg === outsideOverageArea.key) {
        showOutsideOverageAreaToast()
        deleteGeoJson()
        return
      }

      const proceed = await confirm({
        confirmation: `You have selected ${res} parcels. Do you want to proceed?`,
      })
      if (proceed) {
        setDragAcres(0)
        let endpoint = '/initial_query_parcel'
        let params = {
          bounds: turf.bbox(e.features[0].geometry),
          session_key: localAuth.sessionKey,
        }
        setLoading(true)
        callAPI(endpoint, params).then(async (res) => {
          setLoading(false)
          deleteGeoJson()
          if (Object.keys(res.geojson).length && res.geojson.features.length) {
            let aoi_parcels = []
            let mergedGeojson = res.geojson
            const sources = mapRef.current.getStyle().sources
            const prevApnSource = sources['initial_APN_source']
            if (prevApnSource) {
              mergedGeojson = {
                ...prevApnSource.data,
                features: [
                  ...prevApnSource.data.features,
                  ...res.geojson.features,
                ],
              }
            } else {
              setInitialParcels(aoi_parcels)
            }

            // Process the new parcels
            mergedGeojson.features.map(async (feature, index) => {
              let imgUrls = []
              aoi_parcels.push({
                type: 'aoi',
                id: feature.id,
                data: {
                  name:
                    'owner' in feature.properties
                      ? feature.properties['owner']
                      : 'Area of Interest',
                  imgUrls: imgUrls,
                  address:
                    'address' in feature.properties
                      ? feature.properties['address']
                      : 'N/A',
                  county:
                    'county_name' in feature.properties
                      ? feature.properties['county_name']
                      : null,
                  apn:
                    'parcel_id' in feature.properties
                      ? feature.properties['parcel_id']
                      : 'N/A',
                  geolocation: {
                    lat: feature.properties['latitude'],
                    lng: feature.properties['longitude'],
                  },
                },
                feature: feature,
              })
            })

            if (aoi_parcels.length > 0) {
              setVisibility({
                ...visibility,
                ['filtered_parcels']: true,
                ['queried_parcels']: sources['APN_source'] ? true : false,
              })
            }

            // Update the state with the new parcels
            setInitialParcels(aoi_parcels.reverse())

            let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
              initialApnLayers(mergedGeojson)

            setInitialApnSource(initialApnSource)
            setInitialApnLayer(initialApnLayer)
            setInitialApnOutlineLayer(initialApnOutlineLayer)

            const bbox = res.geojson.bbox
            const getBoundingBox = (coordinates) => {
              const minLat = Math.min(...coordinates.map((coord) => coord[0]))
              const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
              const minLon = Math.min(...coordinates.map((coord) => coord[1]))
              const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

              return [
                [minLon, minLat],
                [maxLon, maxLat],
              ]
            }

            setMapBounds(
              getBoundingBox([
                [bbox[1], bbox[0]],
                [bbox[3], bbox[2]],
              ])
            )
          }
        })
      } else {
        setDragAcres(0)
        deleteGeoJson()
      }
    })
  }

  // handle filter success
  async function onQueryFilterSuccess(result) {
    setLoading(false)
    deleteGeoJson()
    if (Object.keys(result).length && result.features.length) {
      let aoi_parcels = []
      let mergedGeojson = result
      const sources = mapRef.current.getStyle().sources
      const prevApnSource = sources['initial_APN_source']
      if (prevApnSource) {
        mergedGeojson = {
          ...prevApnSource.data,
          features: [...prevApnSource.data.features, ...result.features],
        }
      } else {
        setInitialParcels(aoi_parcels)
      }

      // Process the new parcels
      mergedGeojson.features.map(async (feature, index) => {
        let imgUrls = []
        aoi_parcels.push({
          type: 'aoi',
          id: feature.id,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            address:
              'mail_address' in feature.properties
                ? feature.properties['mail_address']
                : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'parcel_id' in feature.properties
                ? feature.properties['parcel_id']
                : 'N/A',
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      if (aoi_parcels.length > 0) {
        setVisibility({
          ...visibility,
          ['filtered_parcels']: true,
          ['queried_parcels']: sources['APN_source'] ? true : false,
        })
      }

      // Update the state with the new parcels
      setInitialParcels(aoi_parcels.reverse())

      let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
        initialApnLayers(mergedGeojson)
      setInitialApnSource(initialApnSource)
      setInitialApnLayer(initialApnLayer)
      setInitialApnOutlineLayer(initialApnOutlineLayer)

      setTimeout(() => {
        const bbox = result.bbox
        const getBoundingBox = (coordinates) => {
          const minLat = Math.min(...coordinates.map((coord) => coord[0]))
          const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
          const minLon = Math.min(...coordinates.map((coord) => coord[1]))
          const maxLon = Math.max(...coordinates.map((coord) => coord[1]))
          return [
            [minLon, minLat],
            [maxLon, maxLat],
          ]
        }
        setMapBounds(
          getBoundingBox([
            [bbox[1], bbox[0]],
            [bbox[3], bbox[2]],
          ])
        )
      }, 100)
    } else {
      deleteGeoJson()
      setInitialMarker(false)
      setInitialParcels([])
      setInitialApnSource({})
      setInitialApnLayer({})
      setInitialApnOutlineLayer({})
    }
  }

  async function handleApnSearch(county, apns) {
    let endpoint = '/initial_query_parcel'
    const params = {
      county: county,
      apns: apns,
      session_key: localAuth.sessionKey,
    }
    deleteGeoJson()
    setInitialMarker(false)
    setInitialParcels([])
    setInitialApnSource({})
    setInitialApnLayer({})
    setInitialApnOutlineLayer({})
    if (!isLoggedIn) return
    setLoading(true)
    let res = await callAPI(endpoint, params)
    setLoading(false)
    if (res.status === 'fail') {
      setInitialMarker(false)
      if (res.msg === outsideOverageArea.key) {
        showOutsideOverageAreaToast()
      } else {
        toast.warn(res.msg)
      }
      return
    } else if (res.status === 'expire') {
      setInitialMarker(false)
      toast.warn(res.msg)
      logout()
      return
    }
    const result = res.geojson
    setLoading(false)
    deleteGeoJson()
    if (Object.keys(result).length && result.features.length) {
      let aoi_parcels = []
      let mergedGeojson = result
      const sources = mapRef.current.getStyle().sources
      const prevApnSource = sources['initial_APN_source']
      if (prevApnSource) {
        mergedGeojson = {
          ...prevApnSource.data,
          features: [...prevApnSource.data.features, ...result.features],
        }
      } else {
        setInitialParcels(aoi_parcels)
      }

      // Process the new parcels
      mergedGeojson.features.map(async (feature, index) => {
        let imgUrls = []
        aoi_parcels.push({
          type: 'aoi',
          id: feature.id,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            address:
              'mail_address' in feature.properties
                ? feature.properties['mail_address']
                : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'parcel_id' in feature.properties
                ? feature.properties['parcel_id']
                : 'N/A',
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      if (aoi_parcels.length > 0) {
        setVisibility({
          ...visibility,
          ['filtered_parcels']: true,
          ['queried_parcels']: sources['APN_source'] ? true : false,
        })
      }

      // Update the state with the new parcels
      setInitialParcels(aoi_parcels.reverse())

      let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
        initialApnLayers(mergedGeojson)
      setInitialApnSource(initialApnSource)
      setInitialApnLayer(initialApnLayer)
      setInitialApnOutlineLayer(initialApnOutlineLayer)

      setTimeout(() => {
        const bbox = result.bbox
        const getBoundingBox = (coordinates) => {
          const minLat = Math.min(...coordinates.map((coord) => coord[0]))
          const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
          const minLon = Math.min(...coordinates.map((coord) => coord[1]))
          const maxLon = Math.max(...coordinates.map((coord) => coord[1]))
          return [
            [minLon, minLat],
            [maxLon, maxLat],
          ]
        }
        setMapBounds(
          getBoundingBox([
            [bbox[1], bbox[0]],
            [bbox[3], bbox[2]],
          ])
        )
      }, 200)
    } else {
      console.log('Here')
    }
  }

  async function initialQueryApn(
    county = '',
    apn = '',
    lat = 0,
    lon = 0,
    append = false,
    rightClick = false,
    locations = []
  ) {
    let params = {}

    let endpoint = '/initial_query_parcel'
    if (county !== '' && apn !== '') {
      params = { county: county, apns: apn, session_key: localAuth.sessionKey }
    } else if (lat !== 0 && lon !== 0) {
      params = { lat: lat, lon: lon, session_key: localAuth.sessionKey }
    } else if (locations.length !== 0) {
      params = { locations: locations, session_key: localAuth.sessionKey }
    }
    deleteGeoJson()
    if (isLoggedIn) {
      setLoading(true)
      let res = await callAPI(endpoint, params)
      if (res.status === 'fail') {
        setInitialMarker(false)

        setLoading(false)
        if (res.msg === outsideOverageArea.key) {
          showOutsideOverageAreaToast()
        } else {
          toast.warn(res.msg)
        }
        return
      } else if (res.status === 'expire') {
        setInitialMarker(false)
        toast.warn(res.msg)
        setLoading(false)
        logout()
        return
      }

      if ((county !== '' && apn !== '') || locations.length !== 0) {
        let bbox = res.geojson.bbox
        const getBoundingBox = (coordinates) => {
          const minLat = Math.min(...coordinates.map((coord) => coord[0]))
          const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
          const minLon = Math.min(...coordinates.map((coord) => coord[1]))
          const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

          return [
            [minLon, minLat],
            [maxLon, maxLat],
          ]
        }
        setMapBounds(
          getBoundingBox([
            [bbox[1], bbox[0]],
            [bbox[3], bbox[2]],
          ])
        )
      }

      if (county !== '' && apn !== '') {
        setFilterGeoJson(res.geojson)
        setVisibility((visibility) => ({
          ...visibility,
          ['filtered_parcels']: true,
        }))
      } else {
        // Create an array to store the new parcels
        let aoi_parcels = []
        if (lat !== 0 && lon !== 0) {
          res.geojson.features[0].properties.latitude = lat.toFixed(5)
          res.geojson.features[0].properties.longitude = lon.toFixed(5)
        }

        // Merge the new GeoJSON with the existing one if append is true
        let mergedGeoJson = res.geojson
        const sources = mapRef.current.getStyle().sources
        const prevSource = sources['initial_APN_source']

        if (append && prevSource) {
          mergedGeoJson = {
            ...prevSource.data,
            features: [...prevSource.data.features, ...res.geojson.features],
          }
        }
        // Process the new parcels
        mergedGeoJson.features.map(async (feature, index) => {
          let imgUrls = []
          aoi_parcels.push({
            type: 'aoi',
            id: feature.id,
            data: {
              name:
                'owner' in feature.properties
                  ? feature.properties['owner']
                  : 'Area of Interest',
              imgUrls: imgUrls,
              address:
                'address' in feature.properties
                  ? feature.properties['address']
                  : 'N/A',
              county:
                'county_name' in feature.properties
                  ? feature.properties['county_name']
                  : null,
              apn:
                'parcel_id' in feature.properties
                  ? feature.properties['parcel_id']
                  : 'N/A',
              // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
              geolocation: {
                lat: feature.properties['latitude'],
                lng: feature.properties['longitude'],
              },
            },
            feature: feature,
          })
        })

        // Update the state with the new parcels
        setInitialParcels(aoi_parcels)

        let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
          initialApnLayers(mergedGeoJson)

        setInitialApnSource(initialApnSource)
        setInitialApnLayer(initialApnLayer)
        setInitialApnOutlineLayer(initialApnOutlineLayer)
        setClickedGeojson(res.geojson)

        if (rightClick) {
          let unionFeatures = null
          mergedGeoJson.features.forEach((feature) => {
            if (unionFeatures) {
              // Union with the previous geometry
              unionFeatures = turf.union(unionFeatures, feature)
            } else {
              // Initialize the union geometry with the first feature
              unionFeatures = feature
            }
          })
          setShowInitialRightClickPopup(true)
          setPopupLat(lat)
          setPopupLon(lon)
        }
      }

      setLoading(false)
    }
  }

  async function queryApn(
    county = '',
    apn = '',
    lat = '',
    lon = '',
    geom = '',
    geojsonStr = '',
    append = false
  ) {
    let params = {}
    let endpoint = '/query_parcel'
    if (county !== '' && apn !== '') {
      params = { county: county, apns: apn, session_key: localAuth.sessionKey }
    } else if (lat !== '' && lon !== '') {
      params = { lat: lat, lon: lon, session_key: localAuth.sessionKey }
      // let endpoint = "/pt2dfHC2"
    } else if (geom !== '') {
      let area = turf.area(geom)
      let sq_ac = Math.round(area * 0.000247105 * 100) / 100
      if (sq_ac > 2000) {
        toast.warn(
          'The selected area is too large to process. Please try again with a smaller area.'
        )
        deleteGeoJson()
        setLoading(false)
        return
      }
      params = { bounds: turf.bbox(geom), session_key: localAuth.sessionKey }
    } else if (geojsonStr !== '') {
      params = { geojson_str: geojsonStr, session_key: localAuth.sessionKey }
    }
    setInitialMarker(false)
    deleteGeoJson()

    if (isLoggedIn) {
      setLoading(true)
      let res = await callAPI(endpoint, params)
      if (res.status === 'fail') {
        toast.warn(res.msg)
        deleteGeoJson()
        setLoading(false)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        deleteGeoJson()
        setLoading(false)
        logout()
        return
      } else if (res.status === 'quota maximum') {
        if (isFreeTrial) {
          setTrialLimitState(TrialLimitType.PARCEL_QUERY_LIMIT)
        } else {
          toast.warn(
            'You are querying more properties than your monthly quota allows. Please try again later.'
          )
        }

        deleteGeoJson()
        setLoading(false)
        return
      }

      // var res = {'geojson': QueriedGeoJson}

      const prevSource = mapRef.current.getStyle().sources['initial_APN_source']
      const newParcelIds = res.geojson.features.map(
        (feature) => feature.properties.parcel_id
      )

      if (prevSource) {
        // Filter the features array
        const filteredFeatures = prevSource.data.features.filter(
          (prevFeature) => {
            const parcelId = prevFeature.properties.parcel_id
            const shortenedParcelId = parcelId.slice(0, -3)

            return (
              !newParcelIds.includes(parcelId) &&
              !newParcelIds.includes(shortenedParcelId)
            )
          }
        )

        // Create a new GeoJSON object with the filtered features
        const updatedPrevGeojson = {
          ...prevSource.data, // Keep all the existing properties of prevSource.data
          features: filteredFeatures, // Replace the features array with the filtered one
        }
        let { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
          initialApnLayers(updatedPrevGeojson)

        setInitialApnSource(initialApnSource)
        setInitialApnLayer(initialApnLayer)
        setInitialApnOutlineLayer(initialApnOutlineLayer)
        setShowInitialRightClickPopup(false)
        setInitialParcels((prevParcels) => {
          // Return a new array excluding the parcel with the matching parcelId
          return prevParcels.filter(
            (parcel) =>
              !newParcelIds.includes(parcel.feature.properties.parcel_id)
          )
        })
      }

      let aoi_parcels = []

      let mergedGeoJson = res.geojson
      const sources = mapRef.current.getStyle().sources
      const prevApnSource = sources['APN_source']
      if (append && prevApnSource) {
        mergedGeoJson = {
          ...prevApnSource.data,
          features: [...prevApnSource.data.features, ...res.geojson.features],
        }
      } else {
        setParcels(aoi_parcels)
      }
      // Process the new parcels
      mergedGeoJson.features.map(async (feature, index) => {
        let imgUrls = []
        if ('sv' in feature.properties) {
          // Convert the binary string to a Base64-encoded string
          const base64Image = btoa(feature.properties['sv'])
          // Create a data URL for the image
          imgUrls.push(`data:image/png;base64,${base64Image}`)
        }
        feature.id = index
        const hydraScore =
          'hs' in feature.properties
            ? feature.properties['hs'] === 'not yet rated'
              ? 'NR'
              : feature.properties['hs']
            : 'NR'
        const ss =
          'ss' in feature.properties
            ? feature.properties['ss'] === null
              ? 'NR'
              : feature.properties['ss']
            : 'NR'
        aoi_parcels.push({
          type: 'aoi',
          id: index,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            timestamp: false,
            address:
              'mail_address' in feature.properties
                ? feature.properties['mail_address']
                : 'N/A',
            hydraScore: hydraScore,
            ss: ss,
            regularPrice:
              'price' in feature.properties
                ? feature.properties['price']
                : 'mkt_val_bldg' in feature.properties ||
                    'mkt_val_land' in feature.properties
                  ? '$' +
                    (
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_bldg)
                      ) +
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_land)
                      )
                    ).toString()
                  : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'parcel_id' in feature.properties
                ? feature.properties['parcel_id']
                : 'N/A',
            gsa: feature.properties['gsa_info']
              ? feature.properties['gsa_info'].map((gsa) => gsa.gsa_name)
              : ['N/A'],
            wd: feature.properties['wd_info']
              ? feature.properties['wd_info'].map((wd) => wd.wd_name)
              : ['N/A'],
            acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      if (aoi_parcels.length > 0) {
        setVisibility({
          ...visibility,
          ['queried_parcels']: true,
        })
      }

      setParcels(aoi_parcels.reverse())

      let { apnSource, apnLayer, apnOutlineLayer, apnLabelLayer } = apnLayers(
        mapRef.current,
        mergedGeoJson,
        enableAPNDisplay
      )

      setApnSource(apnSource)
      setApnLayer(apnLayer)
      setApnOutlineLayer(apnOutlineLayer)
      setApnLabelLayer(apnLabelLayer)

      let bbox = res.geojson.bbox

      const getBoundingBox = (coordinates) => {
        const minLat = Math.min(...coordinates.map((coord) => coord[0]))
        const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
        const minLon = Math.min(...coordinates.map((coord) => coord[1]))
        const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

        return [
          [minLon, minLat],
          [maxLon, maxLat],
        ]
      }

      setMapBounds(
        getBoundingBox([
          [bbox[1], bbox[0]],
          [bbox[3], bbox[2]],
        ])
      )
      setLoading(false)
      return aoi_parcels.reverse()
    }
    return []
  }

  async function drawParcelsByRanchId(ranchId) {
    let endpoint = '/get_parcels_by_ranch_id'
    let params = {
      ranch_ids: [ranchId],
      session_key: localAuth.sessionKey,
    }

    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})

    setLoading(true)
    callAPI(endpoint, params)
      .then((res) => {
        if (res.status === 'fail') {
          toast.warn(res.msg)
          setLoading(false)
          return
        } else if (res.status === 'expire') {
          toast.warn(res.msg)
          setLoading(false)
          logout()
          return
        }
        setLoading(false)

        if (Object.keys(res.parcels).length > 0) {
          let aoi_parcels = []
          setRanchParcels(aoi_parcels)
          res.parcels.features.map(async (feature) => {
            feature['id'] = `100${feature.id}`
            let imgUrls = [feature.properties.sv]
            const hydraScore =
              'hs' in feature.properties
                ? feature.properties['hs'] === 'not yet rated'
                  ? 'NR'
                  : feature.properties['hs']
                : 'NR'
            const ss =
              'ss' in feature.properties
                ? feature.properties['ss'] === null
                  ? 'NR'
                  : feature.properties['ss']
                : 'NR'
            aoi_parcels.push({
              type: 'ranch',
              id: feature.id,
              data: {
                name:
                  'owner' in feature.properties
                    ? feature.properties['owner']
                    : 'Area of Interest',
                imgUrls: imgUrls,
                timestamp: feature.properties.mod_time,
                address:
                  'mail_address' in feature.properties
                    ? feature.properties['mail_address']
                    : 'N/A',
                hydraScore: hydraScore,
                ss: ss,
                regularPrice:
                  'price' in feature.properties
                    ? feature.properties['price']
                    : 'mkt_val_bldg' in feature.properties ||
                        'mkt_val_land' in feature.properties
                      ? '$' +
                        (
                          parseFloat(
                            undefinedToZero(feature.properties.mkt_val_bldg)
                          ) +
                          parseFloat(
                            undefinedToZero(feature.properties.mkt_val_land)
                          )
                        ).toString()
                      : 'N/A',
                county:
                  'county_name' in feature.properties
                    ? feature.properties['county_name']
                    : null,
                apn:
                  'parcel_id' in feature.properties
                    ? feature.properties['parcel_id']
                    : 'N/A',
                gsa: feature.properties['gsa_info']
                  ? feature.properties['gsa_info'].map((gsa) => gsa.gsa_name)
                  : ['N/A'],
                wd: feature.properties['wd_info']
                  ? feature.properties['wd_info'].map((wd) => wd.wd_name)
                  : ['N/A'],
                acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
                geolocation: {
                  lat: feature.properties['latitude'],
                  lng: feature.properties['longitude'],
                },
              },
              feature: feature,
            })
          })
          // Sort parcels by APN in ascending order
          aoi_parcels.sort((a, b) => {
            let apnA = a.data.apn || '' // Default to empty string if undefined
            let apnB = b.data.apn || ''
            return apnA.localeCompare(apnB)
          })
          setRanchParcels(aoi_parcels)

          let {
            ranchApnSource,
            ranchApnLayer,
            ranchApnOutlineLayer,
            ranchApnLabelLayer,
          } = ranchApnLayers(mapRef.current, res.parcels)

          setRanchApnSource(ranchApnSource)
          setRanchApnLayer(ranchApnLayer)
          setRanchApnOutlineLayer(ranchApnOutlineLayer)
          setRanchApnLabelLayer(ranchApnLabelLayer)
          let bbox = getBboxFromGeoJson(res.parcels)

          const getBoundingBox = (coordinates) => {
            const minLat = Math.min(...coordinates.map((coord) => coord[0]))
            const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
            const minLon = Math.min(...coordinates.map((coord) => coord[1]))
            const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

            return [
              [minLon, minLat],
              [maxLon, maxLat],
            ]
          }

          setMapBounds(
            getBoundingBox([
              [bbox[1], bbox[0]],
              [bbox[3], bbox[2]],
            ])
          )
          setLoading(false)
        } else {
          setMapBounds([[], []])
          toast.warn('The ranch you selected does not contain any parcels.')
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (ranchesGeojson) {
      setRanchParcelsSource({})
      setRanchParcelsLayer({})
      setRanchParcelsOutlineLayer({})
      let { ranchParcelsSource, ranchParcelsLayer, ranchParcelsOutlineLayer } =
        allRanchParcels(mapRef.current, ranchesGeojson)
      setRanchParcelsSource(ranchParcelsSource)
      setRanchParcelsLayer(ranchParcelsLayer)
      setRanchParcelsOutlineLayer(ranchParcelsOutlineLayer)
    }
  }, [ranchesGeojson])

  const deleteGeoJson = () => {
    // let mapLayers = mapRef.current.getStyle().layers
    try {
      draw.deleteAll()
    } catch (e) {}
  }

  class QueryFilterButton {
    onAdd(map) {
      this._map = map

      // Create container for both buttons
      this._container = document.createElement('div')
      this._container.className = 'my-custom-controls' // Use flex container for layout

      // Filter Criteria button
      const filterButton = document.createElement('button')
      filterButton.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-query-button' // Keep this class only on the button
      filterButton.textContent = 'Filter Criteria'
      filterButton.type = 'button'

      this._container.appendChild(filterButton)

      // Delete button
      const deleteButton = document.createElement('button')
      deleteButton.className =
        'mapboxgl-ctrl-icon mapboxgl-delete-filter-button cursor-pointer bg-white z-[200]'
      deleteButton.id = 'mapboxgl-delete-filter-button'
      deleteButton.style = 'visibility: hidden'

      deleteButton.type = 'button'
      deleteButton.title = 'Clear all filtered parcels'
      // deleteButton.textContent = 'Hlloe'
      deleteButton.onclick = () => {
        setVisibility({
          ...visibility,
          ['filtered_parcels']: false,
        })
        setFilterGeoJson({})
      }

      // SVG path for MdOutlineDeleteSweep icon
      const deleteIcon = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      )
      deleteIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      deleteIcon.setAttribute('viewBox', '0 0 24 24')
      deleteIcon.setAttribute('fill', 'black')
      deleteIcon.setAttribute('width', '24')
      deleteIcon.setAttribute('height', '24')
      deleteIcon.innerHTML = `
                <path d="M6.00514 9.97515C6.5252 9.97515 6.9468 9.55355 6.9468 9.03349C6.9468 8.51342 6.5252 8.09183 6.00514 8.09183C5.48507 8.09183 5.06348 8.51342 5.06348 9.03349C5.06348 9.55355 5.48507 9.97515 6.00514 9.97515Z" fill="black"/><path d="M3.44166 12.8697C3.96173 12.8697 4.38332 12.4481 4.38332 11.928C4.38332 11.408 3.96173 10.9864 3.44166 10.9864C2.9216 10.9864 2.5 11.408 2.5 11.928C2.5 12.4481 2.9216 12.8697 3.44166 12.8697Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7278 2.85713C18.6619 2.30506 17.3503 2.72156 16.7983 3.78741L14.387 8.44265C14.3741 8.46761 14.3629 8.49302 14.3535 8.51873C13.1724 8.47823 12.0024 8.99998 11.2133 9.92347C10.2836 11.0115 9.13984 12.1989 8.16244 12.8052C6.76894 13.6697 5.61694 13.9812 4.90156 14.0918C4.48315 14.1565 4.14355 14.4259 3.97812 14.7752C3.80532 15.1401 3.81835 15.6182 4.15414 15.9882C4.88416 16.7927 6.3074 18.1103 8.91789 19.7706C10.726 20.9205 12.3471 21.5565 13.2195 21.8512C13.8881 22.077 14.6027 21.8188 14.9863 21.2442C15.4714 20.5177 16.3232 19.1478 17.0546 17.4808C17.5957 16.2476 18.0619 14.9766 18.508 13.7077C18.8843 12.6373 18.715 11.5083 18.1429 10.6158L20.6558 5.79099C21.2111 4.72469 20.7953 3.41008 19.7278 2.85713ZM17.1952 9.62116L19.5028 5.19048C19.726 4.76198 19.5589 4.23368 19.1299 4.01147C18.7015 3.78961 18.1745 3.95699 17.9526 4.38532L15.662 8.80765C15.7387 8.84019 15.8148 8.87556 15.8902 8.9138L16.7272 9.33818C16.8921 9.42176 17.0483 9.51653 17.1952 9.62116ZM17.2816 13.2765C17.189 13.54 17.0913 13.8139 16.9901 14.093L11.7147 11.3246C11.8846 11.1352 12.0475 10.9484 12.2017 10.768C12.9869 9.84904 14.2756 9.55273 15.3023 10.0733L16.1393 10.4977C17.1706 11.0205 17.6582 12.2054 17.2816 13.2765ZM8.84774 13.9099C9.48917 13.512 10.1585 12.9305 10.7866 12.3055L10.795 12.31L16.5321 15.3208C16.3114 15.8946 16.0846 16.456 15.8642 16.9585C15.1735 18.5326 14.365 19.8336 13.9052 20.5223C13.8396 20.6204 13.7332 20.6526 13.6355 20.6196C13.2518 20.49 12.7036 20.2861 12.0502 19.9904C12.3535 19.6706 12.7934 19.1478 13.215 18.4296C13.3972 18.1192 13.2919 17.7252 12.9798 17.5495C12.6678 17.3739 12.2671 17.4831 12.085 17.7935C11.7461 18.3708 11.3322 18.9395 10.8247 19.383C10.4376 19.1741 10.0319 18.9385 9.61554 18.6736C9.277 18.4583 8.95996 18.2495 8.66318 18.0477C8.8176 17.9438 8.98693 17.8165 9.16871 17.6606C9.44209 17.4261 9.46924 17.0208 9.22935 16.7553C8.98946 16.4899 8.57337 16.4647 8.29999 16.6992C7.89764 17.0442 7.61662 17.1755 7.50335 17.2198C6.4683 16.4421 5.77483 15.8036 5.32603 15.338C6.19552 15.1763 7.42378 14.7933 8.84774 13.9099Z" fill="black"/>
            `
      deleteButton.appendChild(deleteIcon)
      this._container.appendChild(deleteButton)

      return this._container
    }
    onRemove() {
      this._container.parentNode.removeChild(this._container)
      this._map = undefined
    }
  }

  const onMapLoad = () => {
    if (mapLoaded) return
    if (mapRef.current) {
      mapRef.current.on('draw.create', onDraw)
      const drawBar = new ExtendDrawBar({
        draw: draw,
        buttons: isMobile
          ? [
              {
                on: 'click',
                action: () => {},
                classes: ['search-apn-icon'],
                title: 'Search by APN',
              },
              {
                on: 'click',
                action: toggleLayers,
                classes: ['layers-icon'],
                title: 'Show Layers',
              },
            ]
          : [
              {
                on: 'click',
                action: drawRectangle,
                classes: ['aoi-icon'],
                title: 'Select by area',
              },
              {
                on: 'click',
                action: () => {},
                classes: ['search-apn-icon'],
                title: 'Search by APN',
              },
              {
                on: 'click',
                action: toggleLayers,
                classes: ['layers-icon'],
                title: 'Show Layers',
              },
            ],
      })

      mapRef.current.addControl(geocoder, 'top-left')

      // Add the Query by Filter button
      const queryFilterButton = new QueryFilterButton()
      mapRef.current.addControl(queryFilterButton, 'top-left') // Right after geocoder

      mapRef.current.addControl(drawBar, 'top-left')
      mapRef.current.getCanvas().style.cursor = 'default'

      let touchStartX = 0
      let touchStartY = 0
      let isTouchMove = false
      let lastTapTime = 0
      const moveThreshold = 10 // Threshold for touch movement to avoid false triggers
      const doubleTapDelay = 300 // Time threshold to detect double-tap (300ms)

      // Handle touchstart event
      function handleTouchStart(event) {
        const touch = event.point // Get the first touch point
        touchStartX = touch.x
        touchStartY = touch.y
        isTouchMove = false // Reset the touch-move flag
      }

      // Handle touchmove event
      function handleTouchMove(event) {
        const touch = event.point
        const moveX = Math.abs(touch.x - touchStartX)
        const moveY = Math.abs(touch.y - touchStartY)

        // If the movement exceeds the threshold, consider it as a touchmove
        if (moveX > moveThreshold || moveY > moveThreshold) {
          isTouchMove = true
        }
      }

      // Handle touchend event to detect single-tap and double-tap
      function handleTouchEnd(event) {
        const currentTime = new Date().getTime()
        const timeDifference = currentTime - lastTapTime

        // Only proceed if no touchmove happened
        if (!isTouchMove) {
          if (timeDifference < doubleTapDelay && timeDifference > 0) {
            // Double-tap detected
            const dblClickEvent = { ...event, type: 'dblclick' }
            defaultClickEvent(dblClickEvent)
            lastTapTime = 0 // Reset lastTapTime to avoid immediate double-tap triggers
          } else {
            // Not a double-tap; wait to confirm it’s a single tap
            lastTapTime = currentTime
            setTimeout(() => {
              // Confirm no double-tap followed, then trigger single tap
              if (lastTapTime === currentTime) {
                defaultClickEvent(event)
              }
            }, doubleTapDelay)
          }
        }
      }

      // Add touch event listeners to the mapRef element
      mapRef.current.on('touchstart', handleTouchStart)
      mapRef.current.on('touchmove', handleTouchMove)
      mapRef.current.on('touchend', handleTouchEnd)

      const navigationControl = new CustomNavigationControl({
        showCompass: true,
        showZoom: true,
      })
      mapRef.current.addControl(navigationControl, 'top-left')

      mapRef.current.setGlyphs(
        'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf'
      )
      let { layerList } = martinVectorTileLayers(mapRef.current, localAuth)
      setLayerList(layerList)
      fitToMapBounds()
      setMapLoaded(true)
    }
  }

  const [showPopup, setShowPopup] = useState(false)
  const [showClickPopup, setShowClickPopup] = useState(false)
  const [showParcelPopup, setShowParcelPopup] = useState(false)
  const [showInitialRightClickPopup, setShowInitialRightClickPopup] =
    useState(false)
  const [showRightClickPopup, setShowRightClickPopup] = useState(false)
  const [showRanchRightClickPopup, setShowRanchRightClickPopup] =
    useState(false)
  const [showFilterRightClickPopup, setShowFilterRightClickPopup] =
    useState(false)
  const [leftClickParcelId, setRightClickParcelId] = useState('')

  const [popupParcel, setPopupParcel] = useState({})
  const [isLoopnetProperty, setIsLoopnetProperty] = useState(false)
  const [popupLat, setPopupLat] = useState(0)
  const [popupLon, setPopupLon] = useState(0)
  const [layerPopupLat, setLayerPopupLat] = useState(0)
  const [layerPopupLon, setLayerPopupLon] = useState(0)
  const [layerPopupText, setLayerPopupText] = useState('')

  const [layerClickPopupLat, setLayerClickPopupLat] = useState(0)
  const [layerClickPopupLon, setLayerClickPopupLon] = useState(0)
  const [layerClickPopupText, setLayerClickPopupText] = useState('')

  useEffect(() => {
    if (mapRef.current) {
      let properties = {
        state_wide_parcels_2024: {
          owner: 'Owner',
          parcel_id: 'APN',
        },
        hydra_wd_vw: {
          agencyname: 'Agency Name',
          source: 'Source',
          rating: 'Rating',
        },
        hydra_gsa: {
          gsa_name: 'GSA Name',
          basin: 'Basin',
          poc_name: 'POC Name',
          poc_phone: 'POC Phone',
          poc_email: 'POC Email',
        },
        rated_wd_mat_vw: {
          feature: 'Region',
        },
        rated_gsa_mat_vw: {
          feature: 'Region',
        },
        sgma_sagbi: {
          compname: 'Component Name',
          taxsubgrp: 'Taxonomy Subgroup',
          sagbi: 'SAGBI',
          rat_grp: 'rating',
          restrictns: 'Restrictions',
        },
        sgma_sagbi_unmod: {
          compname: 'Component Name',
          taxsubgrp: 'Taxonomy Subgroup',
          sagbi: 'SAGBI',
          rat_grp: 'rating',
          restrictns: 'Restrictions',
        },
        sgma_ewrims: {
          'ewrims.points_of_diversion.diversion_site_name': 'Site Name',
          'gis2ewrims.mv_gis_pod_attributes.appl_pod': 'Appl Pod',
          'gis2ewrims.mv_gis_pod_attributes.direct_div_amount':
            'Direct Div Amount',
          'gis2ewrims.mv_gis_pod_attributes.diversion_storage_amount':
            'Storage Amount',
          'gis2ewrims.mv_gis_pod_attributes.diversion_ac_ft': 'Acreage',
          'gis2ewrims.mv_gis_pod_attributes.pod_status': 'Status',
          'gis2ewrims.mv_gis_pod_attributes.storage_type': 'Storage Type',
          'gis2ewrims.mv_gis_pod_attributes.pod_unit': 'Unit',
        },
        ca_grape_pricing_districts: {
          district: 'District Number',
          district_notes: 'District Notes',
        },
        all_ranches: {
          ranch_name: 'Ranch Name',
          ranch_acreage: 'Ranch Acreage',
          ranch_hydra_score: 'Ranch Hydra Score',
          ss: 'Soil Score',
        },
      }
      layerList.forEach((layer) => {
        // Handling mousemove
        // mapRef.current.on('mousemove', layer[1].id, function (e) {
        //     if(enableClick && properties.hasOwnProperty(layer[1]["source-layer"])){
        //         let props_properties = '';
        //         for (const [k, v] of Object.entries(properties[layer[1]["source-layer"]])) {
        //             props_properties += `<div key="${v}" style="font-size:16px">${v} : <strong>` + undefinedToEmpty(e.features[0].properties[k]) + `</strong><br></div>`;
        //         }
        //         const coordinates = e.lngLat;
        //         setLayerPopupLat(coordinates.lat);
        //         setLayerPopupLon(coordinates.lng);
        //         setLayerPopupText(props_properties);
        //         setShowPopup(true);
        //     }
        // });

        let enableClick = false
        mapRef.current.on('touchmove', layer[1].id, function (e) {
          enableClick = true
        })
        mapRef.current.on('touchend', layer[1].id, function (e) {
          enableClick = !enableClick

          if (enableClick) {
            let props_properties = ''
            if (!properties.hasOwnProperty(layer[1]['source-layer'])) return
            for (const [k, v] of Object.entries(
              properties[layer[1]['source-layer']]
            )) {
              props_properties +=
                `<div key="${v}" style="font-size:16px">${v} : <strong>` +
                (k === 'rating'
                  ? e.features[0].properties[k] === '-1'
                    ? 'Not Yet Rated'
                    : undefinedToEmpty(e.features[0].properties[k])
                  : undefinedToEmpty(e.features[0].properties[k])) +
                `</strong><br></div>`
            }
            const coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })

        mapRef.current.on('touchend', 'All Ranches', function (e) {
          enableClick = !enableClick

          if (enableClick) {
            let props_properties = ''
            for (const [k, v] of Object.entries(properties['all_ranches'])) {
              props_properties +=
                `
                                <div key="${v}" style="font-size:16px">${v} : <strong>` +
                undefinedToEmpty(e.features[0].properties[k]) +
                `</strong><br></div>
                                `
            }
            let coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })

        mapRef.current.on('click', layer[1].id, function (e) {
          enableClick = !enableClick

          if (enableClick) {
            let props_properties = ''
            if (!properties.hasOwnProperty(layer[1]['source-layer'])) return
            for (const [k, v] of Object.entries(
              properties[layer[1]['source-layer']]
            )) {
              props_properties +=
                `<div key="${v}" style="font-size:16px">${v} : <strong>` +
                (k === 'rating'
                  ? e.features[0].properties[k] === '-1'
                    ? 'Not Yet Rated'
                    : undefinedToEmpty(e.features[0].properties[k])
                  : undefinedToEmpty(e.features[0].properties[k])) +
                `</strong><br></div>`
            }
            const coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })
        // Optionally handle mouseleave to hide the popup when mouse leaves the layer
        mapRef.current.on('mouseleave', layer[1].id, function (e) {
          setShowPopup(false)
          // setShowClickPopup(false);
        })
      })
      mapRef.current.on('mousemove', 'All Ranches', function (e) {
        let props_properties = ''
        for (const [k, v] of Object.entries(properties['all_ranches'])) {
          props_properties +=
            `
                        <div key="${v}" style="font-size:16px">${v} : <strong>` +
            undefinedToEmpty(e.features[0].properties[k]) +
            `</strong><br></div>
                        `
        }
        let coordinates = e.lngLat
        setLayerPopupLat(coordinates.lat)
        setLayerPopupLon(coordinates.lng)
        setLayerPopupText(props_properties)
        // setShowParcelPopup(false)
        setShowPopup(true)
      })
      mapRef.current.on('click', 'All Ranches', function (e) {
        setShowPopup(false)
        setShowClickPopup(false)
      })
      mapRef.current.on('mouseleave', 'All Ranches', function (e) {
        setShowPopup(false)
        setShowClickPopup(false)
      })
    }
  }, [layerList])

  const [visibility, setVisibility] = useState({
    rated_wd_mat_vw: false,
    rated_gsa_mat_vw: false,
    sgma_county: false,
    hydra_gsa: false,
    hydra_wd_vw: false,
    state_wide_parcels_2024: false,
    sgma_sagbi: false,
    sgma_sagbi_unmod: false,
    provisional_crops_2023: false,
    sgma_ewrims: false,
    all_ranches: false,
    queried_parcels: false,
    aac_ca_region: false,
    fca_territories_2024: false,
    ca_grape_pricing_districts: false,
    yfc_territory: false,
  })

  const [aoiVisibility, setAoiVisibility] = useState({
    apn: false,
    sagbi: false,
    mls: false,
  })

  const [selectedCounty, setSelectedCounty] = useState(null)
  const [selectedApn, setSelectedApn] = useState(null)

  const onVisibilityChange = (name, value) => {
    setVisibility({
      ...visibility,
      [name]: value,
    })
    setShowClickPopup(false)
  }

  const onBaseMapVisibilityChange = (name, value) => {
    if (!value) {
      toast.warn('One of the base maps must be selected.')
      return
    }

    // Create a new object with all values set to false
    const newVisibility = Object.fromEntries(
      Object.keys(baseMapVisibility).map((key) => [key, false])
    )

    // Set the specific key to true
    newVisibility[name] = value
    // Update state
    setBaseMapVisibility(newVisibility)
  }

  useEffect(() => {
    const newBaseMapSourceStyles = {
      Aerial: {
        key: 'google_aerial',
        id: 'google_aerial',
        type: 'raster',
        tiles: ['https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'],
        tileSize: 256,
      },
      Dark: {
        key: 'dark_matter',
        id: 'dark_matter',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
        ],
      },
      Light: {
        key: 'positron',
        id: 'positron',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        ],
      },
      Topo: {
        key: 'topography',
        id: 'topography',
        type: 'raster',
        tiles: [
          'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
          'https://b.tile.opentopomap.org/{z}/{x}/{y}.png',
          'https://c.tile.opentopomap.org/{z}/{x}/{y}.png',
        ],
      },
      Streets: {
        key: 'streets',
        id: 'streets',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
        ],
      },
    }
    const newBaseMapLayerStyles = {
      Aerial: {
        key: 'Aerial',
        id: 'Aerial',
        type: 'raster',
        source: 'google_aerial',
        layout: {
          visibility: baseMapVisibility['Aerial'] ? 'visible' : 'none',
        },
      },
      Dark: {
        key: 'Dark',
        id: 'Dark',
        type: 'raster',
        source: 'dark_matter',
        layout: { visibility: baseMapVisibility['Dark'] ? 'visible' : 'none' },
      },
      Light: {
        key: 'Light',
        id: 'Light',
        type: 'raster',
        source: 'positron',
        layout: { visibility: baseMapVisibility['Light'] ? 'visible' : 'none' },
      },
      Topo: {
        key: 'Topo',
        id: 'Topo',
        type: 'raster',
        source: 'topography',
        layout: { visibility: baseMapVisibility['Topo'] ? 'visible' : 'none' },
      },
      Streets: {
        key: 'Streets',
        id: 'Streets',
        type: 'raster',
        source: 'streets',
        layout: {
          visibility: baseMapVisibility['Streets'] ? 'visible' : 'none',
        },
      },
    }
    setBaseMapSourceStyles(newBaseMapSourceStyles)
    setBaseMapLayerStyles(newBaseMapLayerStyles)
  }, [baseMapVisibility])

  const onMarkerClick = (e, ln_prop) => {
    // Set the popupInfo state to trigger the rendering of the popup
    lnProperties.map((property) => {
      if (property.id == ln_prop.id) {
        setPopupParcel(property)
      }
    })
    let coordinates = e.target._lngLat
    setIsLoopnetProperty(true)
    setPopupLat(coordinates.lat)
    setPopupLon(coordinates.lng)
    setShowParcelPopup(true)
  }

  const onCountyDropdownChange = (e) => {
    e.preventDefault(e)
    setSelectedCounty(e.target.value)
  }

  const onRanchDropdownChange = (e) => {
    const ranch = ranches.find((item) => item.ranch_name === e.value)
    setShowParcelPopup(false)
    setSelectedRanch(ranch)
  }

  const fitToMapBounds = () => {
    if (!isMobile && mapRef.current && mapBounds[0].length > 0) {
      mapRef.current.fitBounds(mapBounds, {
        padding: 200,
        duration: 1000,
      })
    } else if (mapRef.current && mapBounds[0].length > 0) {
      const _mapBoundsCenter = [
        (mapBounds[0][0] + mapBounds[1][0]) / 2,
        (mapBounds[0][1] + mapBounds[1][1]) / 2,
      ]
      mapRef.current.flyTo({
        center: _mapBoundsCenter,
        zoom: 14,
        essential: true,
      })
    }
  }

  useEffect(() => {
    fitToMapBounds()
  }, [mapBounds])

  useEffect(() => {
    if (Object.keys(selectedRanch).length) {
      drawParcelsByRanchId(selectedRanch.ranch_id)
    }
  }, [selectedRanch])

  const {
    setBaseLayerMapVisibility,
    baseMapLayerVisibility,
    dataLayerVisibility,
    setDataLayerVisibility,
    setMapLayerView,
    mapLayerView,
  } = useMapStore()

  // Hook set
  useEffect(() => {
    setBaseLayerMapVisibility(baseMapVisibility)
    setDataLayerVisibility(visibility)
  }, [baseMapVisibility, visibility])

  const handleMoveEnd = useCallback(
    (evt) => {
      setMapLayerView({
        zoom: evt.viewState.zoom,
        latitude: evt.viewState.latitude,
        longitude: evt.viewState.longitude,
        bearing: evt.viewState.bearing,
        pitch: evt.viewState.pitch,
      })
    },
    [mapLayerView]
  )

  // Hook init
  useEffect(() => {
    setBaseMapVisibility(baseMapLayerVisibility)
    setVisibility(dataLayerVisibility)
    setTimeout(() => {
      mapRef?.current?.flyTo({
        center: [mapLayerView.longitude, mapLayerView.latitude],
        zoom: mapLayerView.zoom,
        bearing: mapLayerView.bearing,
        pitch: mapLayerView.pitch,
        duration: 100,
        essential: true,
      })
    }, 100)
  }, [])

  const refBox = useRef(null)
  const refTop = useRef(null)
  const refLeft = useRef(null)

  useEffect(() => {
    if (refBox.current) {
      const resizableElement = refBox.current
      const styles = window.getComputedStyle(resizableElement)
      let height = parseInt(styles.height, 10)

      let yCord = 0

      // Top
      const onMouseMoveTopResize = (event) => {
        let eventY = event.touches ? event.touches[0]['clientY'] : event.clientY
        const dy = eventY - yCord
        let tmpHeight = height - dy
        yCord = eventY
        if (isNaN(tmpHeight)) return
        height = tmpHeight < 0 ? 0 : tmpHeight
        resizableElement.style.height = `${height}px`
      }

      const onMouseUpTopResize = (event) => {
        document.removeEventListener('mousemove', onMouseMoveTopResize)
        document.removeEventListener('touchmove', onMouseMoveTopResize)
      }

      const onMouseDownTopResize = (event) => {
        let eventY = event.hasOwnProperty('touches')
          ? event.touches[0]['clientY']
          : event.clientY
        yCord = eventY
        const styles = window.getComputedStyle(resizableElement)
        resizableElement.style.bottom = styles.bottom
        resizableElement.style.top = null
        document.addEventListener('mousemove', onMouseMoveTopResize)
        document.addEventListener('mouseup', onMouseUpTopResize)
        document.addEventListener('touchmove', onMouseMoveTopResize)
        document.addEventListener('touchend', onMouseUpTopResize)
      }

      if (refTop.current) {
        const resizerTop = refTop.current
        resizerTop.addEventListener('mousedown', onMouseDownTopResize)
        resizerTop.addEventListener('touchstart', onMouseDownTopResize)
        return () => {
          resizerTop.removeEventListener('mousedown', onMouseDownTopResize)
          resizerTop.removeEventListener('touchstart', onMouseDownTopResize)
        }
      }
    }
  }, [refBox.current, refTop.current, refLeft.current])
  const [ranchName, setRanchName] = useState('')

  function onChange(e) {
    setRanchName(e.target.value)
  }

  function createRanches(add = false) {
    setLoading(true)
    let endpoint = '/create_ranch'
    let params = {
      ranch_name: ranchName,
      session_key: localAuth.sessionKey,
    }
    callAPI(endpoint, params).then((res) => {
      setLoading(false)
      if (res.status === 'fail') {
        toast.warn(res.msg)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        return
      }
      invalidateQuery()
      setRanches(res.ranches.slice().sort((a, b) => b.ranch_id - a.ranch_id))
      const ranch = res.ranches.find(
        (item) => item.ranch_name === res.ranch_name
      )
      setRanchName('')
      if (add) addParcelToRanch(ranch)
      else setSelectedRanch(ranch)
    })
  }

  async function onSubmit(e, add = false) {
    e.preventDefault()
    if (ranchName === '') {
      toast.warn('Must type ranch name first.')
      return
    } else {
      try {
        createRanches(add)
      } catch (error) {
        toast.warn(error.message)
      }
    }
  }

  return (
    <>
      {!browserName.toLowerCase().includes('chrome') &&
        !browserName.toLowerCase().includes('safari') &&
        !browserName.toLowerCase().includes('webkit') && <BrowserCheck />}
      {loading && <Spinner />}

      <div
        className={`h-full fixed ${
          window.innerWidth >= 690 && !isMobile ? 'flex' : ''
        }`}
      >
        {showModal &&
          (isMobile && !ranchId && !parcelId ? (
            <MobileParcelDetail
              showModal={showModal}
              logout={logout}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              localAuth={localAuth}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              drawParcelsByRanchId={drawParcelsByRanchId}
              onParcelDelete={onParcelDeleteFromDetail}
              onRanchDropdownChange={onRanchDropdownChange}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ) : (
            <ParcelDetail
              showModal={showModal}
              logout={logout}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              localAuth={localAuth}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              drawParcelsByRanchId={drawParcelsByRanchId}
              onParcelDelete={onParcelDeleteFromDetail}
              onRanchDropdownChange={onRanchDropdownChange}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ))}
        {showRanchSelectModal && (
          <RanchSelectModal
            selectedRanch={selectedRanch}
            onChange={onChange}
            ranchName={ranchName}
            onSubmit={(e) => onSubmit(e, true)}
            setSelectedParcelIds={setSelectedParcelIds}
            showRanchSelectModal={showRanchSelectModal}
            setShowRanchSelectModal={setShowRanchSelectModal}
            onRanchDropdownChange={onRanchDropdownChange}
            ranches={ranches}
            setRanches={setRanches}
            addParcelToRanch={addParcelToRanch}
            addInitialParcelToRanch={addInitialParcelToRanch}
            initialRanch={initialRanch}
            setInitialRanch={setInitialRanch}
          />
        )}
        {isSearchOn['apn'] && (
          <ApnSearchModal
            onSearchSuccess={(county, apns) => {
              setIsSearchOn((prevState) => ({
                ...prevState,
                ['apn']: false,
              }))
              setSelectedCounty(null)
              return handleApnSearch(county, apns)
            }}
            handleClose={() => {
              setIsSearchOn((prevState) => ({
                ...prevState,
                ['apn']: false,
              }))
              setSelectedCounty(null)
            }}
            setIsSearchOn={setIsSearchOn}
            isSearchOn={isSearchOn}
            initialQueryApn={initialQueryApn}
            onCountyDropdownChange={onCountyDropdownChange}
            selectedCounty={selectedCounty}
            setSelectedCounty={setSelectedCounty}
            setSelectedApn={setSelectedApn}
            selectedApn={selectedApn}
            queryApn={queryApn}
            setLoading={setLoading}
          />
        )}
        {popupContent && (
          <InfoPopup
            content={popupContent}
            onClose={() => setPopupContent(null)}
          />
        )}
        {firstLogin && releaseNotes !== '' && (
          <ReleasePopup
            date={releaseDate}
            version={releaseVersion}
            content={releaseNotes}
            onClose={() => {
              setFirstLogin(false)
              setJoyrideRun(false)
            }}
            onTryIt={() => {
              setFirstLogin(false)
              setJoyrideRun(false)
            }}
            onShowWhatsNew={() => {
              setFirstLogin(false)
              setJoyrideRun(true)
              navigate(
                '/tutorial' +
                  (searchParams.get('locations')
                    ? '?locations=' + searchParams.get('locations')
                    : '')
              )
            }}
          />
        )}
        {
          <div
            id="layerBox"
            className={`absolute ${
              window.innerWidth < 690 ? 'top-[60px]' : 'top-[45px]'
            } w-[275px] z-[10] left-[-275px] ${
              isLayerOn ? 'move-right' : 'no-move'
            }`}
          >
            <LayerControlGroup
              baseMapVisibility={baseMapVisibility}
              visibility={visibility}
              onBaseMapVisibilityChange={onBaseMapVisibilityChange}
              onVisibilityChange={onVisibilityChange}
              layers={
                isAac
                  ? {
                      'Rated Regions - Water Districts': 'rated_wd_mat_vw',
                      'Rated Regions - GSAs': 'rated_gsa_mat_vw',
                      County: 'sgma_county',
                      GSA: 'hydra_gsa',
                      'Water Districts': 'hydra_wd_vw',
                      'Statewide Parcels': 'state_wide_parcels_2024',
                      'SAGBI - Modified': 'sgma_sagbi',
                      'SAGBI - Unmodified': 'sgma_sagbi_unmod',
                      'Statewide Crops': 'provisional_crops_2023',
                      'Water Rights (eWRIMS)': 'sgma_ewrims',
                      'AAC CA Territory': 'aac_ca_region',
                      'Farm Credit System Institution Territories (2024)':
                        'fca_territories_2024',
                      'Grape Pricing Districts': 'ca_grape_pricing_districts',
                      'All Ranches': 'all_ranches',
                      'Queried Parcel(s)': 'queried_parcels',
                      'Filtered Parcel(s)': 'filtered_parcels',
                    }
                  : isYfc
                    ? {
                        'Rated Regions - Water Districts': 'rated_wd_mat_vw',
                        'Rated Regions - GSAs': 'rated_gsa_mat_vw',
                        County: 'sgma_county',
                        GSA: 'hydra_gsa',
                        'Water Districts': 'hydra_wd_vw',
                        'Statewide Parcels': 'state_wide_parcels_2024',
                        'SAGBI - Modified': 'sgma_sagbi',
                        'SAGBI - Unmodified': 'sgma_sagbi_unmod',
                        'Statewide Crops': 'provisional_crops_2023',
                        'Water Rights (eWRIMS)': 'sgma_ewrims',
                        'YFC Territory': 'yfc_territory',
                        'All Ranches': 'all_ranches',
                        'Queried Parcel(s)': 'queried_parcels',
                        'Filtered Parcel(s)': 'filtered_parcels',
                      }
                    : {
                        'Rated Regions - Water Districts': 'rated_wd_mat_vw',
                        'Rated Regions - GSAs': 'rated_gsa_mat_vw',
                        County: 'sgma_county',
                        GSA: 'hydra_gsa',
                        'Water Districts': 'hydra_wd_vw',
                        'Statewide Parcels': 'state_wide_parcels_2024',
                        'SAGBI - Modified': 'sgma_sagbi',
                        'SAGBI - Unmodified': 'sgma_sagbi_unmod',
                        'Statewide Crops': 'provisional_crops_2023',
                        'Water Rights (eWRIMS)': 'sgma_ewrims',
                        'All Ranches': 'all_ranches',
                        'Queried Parcel(s)': 'queried_parcels',
                        'Filtered Parcel(s)': 'filtered_parcels',
                      }
              }
              isDemoUser={isDemoUser}
              isTutorialPage={false}
              hasQueriedParcels={parcels.map((parcel) => parcel.id).length}
              hasFilteredParcels={Object.keys(filterGeoJson).length > 0}
              setPopupContent={setPopupContent}
            />
          </div>
        }
        {/* Top Centered Text */}
        {dragAcres > 0 && (
          <div className="absolute top-2 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-80 px-4 py-2 rounded-md shadow-md z-50">
            Selected Area: {dragAcres} acres
          </div>
        )}

        <MapProvider>
          <Map
            ref={mapRef}
            onLoad={onMapLoad}
            // initialViewState={{
            //     longitude: searchParams.get("lon") ? searchParams.get("lon") : -120.84801513068955,
            //     latitude: searchParams.get("lat") ? searchParams.get("lat") : 37.05929755303834,
            //     zoom: 14,
            // }}
            onMoveEnd={handleMoveEnd}
            initialViewState={{
              // "latitude": 37.07676,
              // "longitude": -120.88822,
              longitude: SampleGeoJson.feature.properties.longitude,
              latitude: SampleGeoJson.feature.properties.latitude,
              zoom: 14,
            }}
            style={mapWidthStyle}
          >
            <Source
              id="area-label"
              type="geojson"
              data={{ type: 'FeatureCollection', features: [] }}
            >
              {/* <Layer
                    id="area-label-layer"
                    type="symbol"
                    layout={{
                        'text-field': ['get', 'area'],
                        'text-size': 14,
                        'text-anchor': 'top',
                    }}
                    paint={{
                        'text-color': '#ff0000',
                    }}
                /> */}
            </Source>
            {layerList.length > 0 &&
              layerList.map((layer) => {
                if (visibility[layer[0].id]) {
                  return (
                    <Source {...layer[0]}>
                      <Layer {...layer[1]} />
                      {layer.length > 2 && <Layer {...layer[2]} />}
                      {mapLoaded &&
                        layer.length > 3 &&
                        mapRef.current.getGlyphs() ===
                          'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' && (
                          <Layer {...layer[3]} />
                        )}
                    </Source>
                  )
                }
              })}
            {visibility['all_ranches'] &&
              mapRef.current &&
              Object.keys(ranchParcelsSource).length > 0 &&
              Object.keys(ranchParcelsLayer).length > 0 &&
              Object.keys(ranchParcelsOutlineLayer).length > 0 && (
                <Source {...ranchParcelsSource}>
                  <Layer {...ranchParcelsLayer} />
                  <Layer {...ranchParcelsOutlineLayer} />
                </Source>
              )}
            {Object.keys(baseMapSourceStyles).length > 0 &&
              Object.keys(baseMapLayerStyles).length > 0 &&
              Object.keys(baseMapSourceStyles).map((baseMap) => (
                <Source {...baseMapSourceStyles[baseMap]}>
                  <Layer {...baseMapLayerStyles[baseMap]} />
                </Source>
              ))}
            {showPopup && (
              <Popup
                closeButton={false}
                longitude={layerPopupLon}
                latitude={layerPopupLat}
              >
                <div dangerouslySetInnerHTML={{ __html: layerPopupText }} />
              </Popup>
            )}
            {showClickPopup && (
              <Popup
                closeButton={true}
                longitude={layerClickPopupLon}
                latitude={layerClickPopupLat}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: layerClickPopupText }}
                />
              </Popup>
            )}
            {visibility['filtered_parcels'] &&
              Object.keys(filterGeoJson).length > 0 && (
                <Source
                  key={`filter-source`}
                  id={`filter-source`}
                  type="geojson"
                  data={filterGeoJson}
                >
                  <Layer
                    {...{
                      source: `filter-source`,
                      id: `filter-layer`,
                      type: 'fill',
                      layout: { visibility: 'visible' },
                      paint: {
                        'fill-color': '#87ceeb',
                        'fill-opacity': 0.2,
                        'fill-outline-color': '#87ceeb',
                      },
                    }}
                  />
                  <Layer
                    {...{
                      source: `filter-source`,
                      id: `filter-layer-outline`,
                      type: 'line',
                      layout: {
                        visibility: 'visible',
                        'line-join': 'round',
                        'line-cap': 'round',
                      },
                      paint: {
                        'line-color': '#87ceeb',
                        'line-width': 4,
                      },
                    }}
                  />
                  <Layer
                    {...{
                      id: 'filter-layer-label',
                      type: 'symbol',
                      source: 'filter-source',
                      layout: {
                        visibility: 'visible',
                        'icon-image': '',
                        'text-field': [
                          'format',
                          enableAPNDisplay
                            ? ['get', 'parcel_id']
                            : '000-000-000',
                          {
                            'font-scale': 1,
                          },
                          '\n',
                        ],
                        'text-font': ['Roboto Condensed Bold'],
                        'text-offset': [0, 0],
                        'text-letter-spacing': 0,
                        'text-anchor': 'top',
                        'text-size': 14,
                      },
                      paint: {
                        'text-color': '#2c2c2c',
                        'text-halo-color': '#ffffff',
                        'text-halo-width': 2,
                      },
                    }}
                  />
                </Source>
              )}
            {showInitialRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowInitialRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <div>
                    <UpgradeLockIconLayout
                      position="h-[15px]"
                      className="min-w-[60px] h-[15px] "
                      show={!enableAPNDisplay}
                    />
                    <strong>Parcel ID: {leftClickParcelId}</strong>
                  </div>

                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() =>
                        queryApn(
                          '',
                          '',
                          '',
                          '',
                          '',
                          JSON.stringify(clickedGeojson.features),
                          true
                        )
                      }
                    >
                      Query this parcel
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        onClick={() =>
                          queryApn(
                            '',
                            '',
                            '',
                            '',
                            '',
                            JSON.stringify(initialApnSource.data.features),
                            true
                          )
                        }
                      >
                        Query all parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item relative"
                      disabled={!enableCustomRanches}
                      onClick={() => {
                        if (enableCustomRanches) {
                          setInitialRanch(1)
                          setShowRanchSelectModal(true)
                        }
                      }}
                    >
                      <UpgradeLockIconLayout
                        position="top-0"
                        className="min-w-[66px] min-h-[36px] "
                        show={!enableCustomRanches}
                      />
                      Add this parcel to ranch
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item relative"
                        disabled={!enableCustomRanches}
                        onClick={() => {
                          setInitialRanch(2)
                          setShowRanchSelectModal(true)
                        }}
                      >
                        <UpgradeLockIconLayout
                          position="top-0"
                          className="min-w-[66px] min-h-[56px] "
                          show={!enableCustomRanches}
                        />
                        <div>
                          Add all{' '}
                          <strong style={{ color: 'green' }}> selected</strong>{' '}
                          parcels to ranch
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                    {Object.keys(apnSource).length > 0 &&
                    apnSource.data.features.length > 0 ? (
                      <li
                        className="popup-list-item relative"
                        disabled={!enableCustomRanches}
                        onClick={() => {
                          setInitialRanch(0)
                          queryApn(
                            '',
                            '',
                            '',
                            '',
                            '',
                            JSON.stringify(initialApnSource.data.features),
                            true
                          ).then((res) => {
                            onEditAll(res)
                          })
                        }}
                      >
                        <UpgradeLockIconLayout
                          position="top-0"
                          className="min-w-[66px] min-h-[56px] "
                          show={!enableCustomRanches}
                        />
                        <div>
                          Add all{' '}
                          <strong style={{ color: 'green' }}>selected</strong>{' '}
                          and{' '}
                          <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                          parcels to ranch
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        navigator
                          .share({
                            title: 'Hydra score parcel(s)',
                            text: 'Click link to see shared parcel(s)',
                            url: `https://app.hydrascore.com/?locations=${btoa(
                              JSON.stringify([
                                {
                                  lat: clickedGeojson.features[0].properties
                                    .latitude,
                                  lon: clickedGeojson.features[0].properties
                                    .longitude,
                                },
                              ])
                            )}`,
                          })
                          .catch((error) => {
                            console.error('Sharing failed', error)
                          })
                      }}
                    >
                      Share this parcel
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          const locations = initialApnSource.data.features.map(
                            (feature) => {
                              return {
                                lat: feature.properties.latitude,
                                lon: feature.properties.longitude,
                              }
                            }
                          )
                          navigator
                            .share({
                              title: 'Hydra score parcel(s)',
                              text: 'Click link to see shared parcel(s)',
                              url: `https://app.hydrascore.com/?locations=${btoa(
                                JSON.stringify(locations)
                              )}`,
                            })
                            .catch((error) => {
                              console.error('Sharing failed', error)
                            })
                        }}
                      >
                        Share all{' '}
                        <strong style={{ color: 'green' }}>selected</strong>{' '}
                        parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        removeInitialParcels([
                          clickedGeojson.features[0].properties.parcel_id,
                        ])
                      }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <div>
                    <UpgradeLockIconLayout
                      position="h-[15px]"
                      className="min-w-[60px] h-[15px] "
                      show={!enableAPNDisplay}
                    />
                    <strong>Parcel ID: {leftClickParcelId}</strong>
                  </div>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item relative"
                      disabled={!enableCustomRanches}
                      onClick={() => {
                        apnSource.data.features.forEach((feature) => {
                          if (
                            feature.properties.parcel_id == leftClickParcelId
                          ) {
                            setShowRightClickPopup(false)
                            onEdit(feature.id)
                          }
                        })
                      }}
                    >
                      <UpgradeLockIconLayout
                        position="top-0"
                        className="min-w-[66px] min-h-[36px] "
                        show={!enableCustomRanches}
                      />
                      Add this parcel to ranch
                    </li>
                    {apnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item relative"
                        disabled={!enableCustomRanches}
                        onClick={() => {
                          setShowRightClickPopup(false)
                          onEditAll()
                        }}
                      >
                        <UpgradeLockIconLayout
                          position="top-0"
                          className="min-w-[66px] min-h-[36px] "
                          show={!enableCustomRanches}
                        />
                        <div>
                          Add all{' '}
                          <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                          parcels to ranch
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                    {Object.keys(initialApnSource).length > 0 &&
                    initialApnSource.data.features.length > 0 ? (
                      <li
                        className="popup-list-item relative"
                        disabled={!enableCustomRanches}
                        onClick={() => {
                          setInitialRanch(0)
                          queryApn(
                            '',
                            '',
                            '',
                            '',
                            '',
                            JSON.stringify(initialApnSource.data.features),
                            true
                          ).then((res) => {
                            setShowRightClickPopup(false)
                            onEditAll(res)
                          })
                        }}
                      >
                        <UpgradeLockIconLayout
                          position="top-0"
                          className="min-w-[66px] min-h-[56px] "
                          show={!enableCustomRanches}
                        />
                        <div>
                          Add all{' '}
                          <strong style={{ color: 'green' }}>selected</strong>{' '}
                          and{' '}
                          <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                          parcels to ranch
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        apnSource.data.features.forEach((feature) => {
                          if (
                            feature.properties.parcel_id == leftClickParcelId
                          ) {
                            navigator
                              .share({
                                title: 'Hydra score parcel(s)',
                                text: 'Click link to see shared parcel(s)',
                                url: `https://app.hydrascore.com/?locations=${btoa(
                                  JSON.stringify([
                                    {
                                      lat: feature.properties.latitude,
                                      lon: feature.properties.longitude,
                                    },
                                  ])
                                )}`,
                              })
                              .catch((error) => {
                                console.error('Sharing failed', error)
                              })
                          }
                        })
                      }}
                    >
                      Share this parcel
                    </li>
                    {apnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          const locations = apnSource.data.features.map(
                            (feature) => {
                              return {
                                lat: feature.properties.latitude,
                                lon: feature.properties.longitude,
                              }
                            }
                          )
                          navigator
                            .share({
                              title: 'Hydra score parcel(s)',
                              text: 'Click link to see shared parcel(s)',
                              url: `https://app.hydrascore.com/?locations=${btoa(
                                JSON.stringify(locations)
                              )}`,
                            })
                            .catch((error) => {
                              console.error('Sharing failed', error)
                            })
                        }}
                      >
                        Share all{' '}
                        <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                        parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        apnSource.data.features.forEach((feature) => {
                          if (
                            feature.properties.parcel_id == leftClickParcelId
                          ) {
                            setShowRightClickPopup(false)
                            onParcelDelete(feature.id)
                          }
                        })
                      }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showFilterRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowFilterRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <div>
                    <UpgradeLockIconLayout
                      position="h-[15px]"
                      className="min-w-[60px] h-[15px] "
                      show={!enableAPNDisplay}
                    />
                    <strong>Parcel ID: {leftClickParcelId}</strong>
                  </div>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        const updatedGeoJson = {
                          ...filterGeoJson, // Keep all other properties of the GeoJSON
                          features: filterGeoJson.features.filter(
                            (feature) =>
                              feature.properties.parcel_id !== leftClickParcelId
                          ),
                        }
                        setShowFilterRightClickPopup(false)
                        setFilterGeoJson(updatedGeoJson)
                      }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showRanchRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowRanchRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <div>
                    <UpgradeLockIconLayout
                      position="h-[15px]"
                      className="min-w-[60px] h-[15px] "
                      show={!enableAPNDisplay}
                    />
                    <strong>Parcel ID: {leftClickParcelId}</strong>
                  </div>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        ranchApnSource.data.features.forEach((feature) => {
                          if (
                            feature.properties.parcel_id == leftClickParcelId
                          ) {
                            navigator
                              .share({
                                title: 'Hydra score parcel(s)',
                                text: 'Click link to see shared parcel(s)',
                                url: `https://app.hydrascore.com/?locations=${btoa(
                                  JSON.stringify([
                                    {
                                      lat: feature.properties.latitude,
                                      lon: feature.properties.longitude,
                                    },
                                  ])
                                )}`,
                              })
                              .catch((error) => {
                                console.error('Sharing failed', error)
                              })
                          }
                        })
                      }}
                    >
                      Share this parcel
                    </li>
                    {ranchApnSource.data.features.length > 1 && (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          const locations = ranchApnSource.data.features.map(
                            (feature) => {
                              return {
                                lat: feature.properties.latitude,
                                lon: feature.properties.longitude,
                              }
                            }
                          )
                          navigator
                            .share({
                              title: 'Hydra score parcel(s)',
                              text: 'Click link to see shared parcel(s)',
                              url: `https://app.hydrascore.com/?locations=${btoa(
                                JSON.stringify(locations)
                              )}`,
                            })
                            .catch((error) => {
                              console.error('Sharing failed', error)
                            })
                        }}
                      >
                        Share all parcels within the ranch
                      </li>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        ranchApnSource.data.features.forEach((feature) => {
                          if (
                            feature.properties.parcel_id == leftClickParcelId
                          ) {
                            setShowRanchRightClickPopup(false)
                            onRanchParcelDelete(
                              feature.id,
                              feature.properties.ranch_id,
                              feature.properties.parcel_ref_id
                            )
                          }
                        })
                      }}
                    >
                      Remove this parcel from ranch
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showParcelPopup && !isMobile && (
              <Popup
                onClose={() => {
                  setShowParcelPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <>
                  <ParcelCardView
                    page={'/home'}
                    id={popupParcel.id}
                    onParcelDelete={() => onParcelDelete(popupParcel.id)}
                    onRanchParcelDelete={() => {
                      onRanchParcelDelete(
                        popupParcel.id,
                        popupParcel.feature.properties.ranch_id,
                        popupParcel.feature.properties.parcel_ref_id
                      )
                    }}
                    onEdit={() => onEdit(popupParcel.id)}
                    property={popupParcel}
                    onPropertyClicked={onPropertyClicked}
                    handlePropertyMouseOver={handlePropertyMouseOver}
                    handlePropertyMouseOut={handlePropertyMouseOut}
                    isLoopnetProperty={isLoopnetProperty}
                    isDemoUser={isDemoUser}
                    setLoading={setLoading}
                    setPopupContent={setPopupContent}
                  />
                </>
              </Popup>
            )}
            {/* APN Display */}
            {mapLoaded &&
            mapRef.current &&
            mapRef.current?.getGlyphs() ===
              'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' &&
            Object.keys(apnSource).length > 0 &&
            Object.keys(apnLayer).length > 0 &&
            Object.keys(apnOutlineLayer).length > 0 &&
            Object.keys(apnLabelLayer).length > 0
              ? visibility['queried_parcels'] && (
                  <Source {...apnSource}>
                    <Layer {...apnLayer} />
                    <Layer {...apnOutlineLayer} />
                    <Layer {...apnLabelLayer} />
                  </Source>
                )
              : mapRef.current &&
                Object.keys(apnSource).length > 0 &&
                Object.keys(apnLayer).length > 0 &&
                Object.keys(apnOutlineLayer).length > 0 &&
                Object.keys(apnLabelLayer).length > 0 &&
                visibility['queried_parcels'] && (
                  <Source {...apnSource}>
                    <Layer {...apnLayer} />
                    <Layer {...apnOutlineLayer} />
                  </Source>
                )}
            {mapLoaded &&
              mapRef.current &&
              Object.keys(initialApnSource).length > 0 &&
              Object.keys(initialApnLayer).length > 0 &&
              Object.keys(initialApnOutlineLayer).length > 0 && (
                <Source {...initialApnSource}>
                  <Layer {...initialApnLayer} />
                  <Layer {...initialApnOutlineLayer} />
                </Source>
              )}
            {mapLoaded &&
            mapRef.current &&
            mapRef.current?.getGlyphs() ===
              'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' &&
            Object.keys(ranchApnSource).length > 0 &&
            Object.keys(ranchApnLayer).length > 0 &&
            Object.keys(ranchApnOutlineLayer).length > 0 &&
            Object.keys(ranchApnLabelLayer).length > 0 ? (
              <Source {...ranchApnSource}>
                <Layer {...ranchApnLayer} />
                <Layer {...ranchApnOutlineLayer} />
                <Layer {...ranchApnLabelLayer} />
              </Source>
            ) : (
              mapRef.current &&
              Object.keys(ranchApnSource).length > 0 &&
              Object.keys(ranchApnLayer).length > 0 &&
              Object.keys(ranchApnOutlineLayer).length > 0 &&
              Object.keys(ranchApnLabelLayer).length > 0 && (
                <Source {...ranchApnSource}>
                  <Layer {...ranchApnLayer} />
                  <Layer {...ranchApnOutlineLayer} />
                </Source>
              )
            )}
            {initialMarker && (
              <Marker
                id="initialMarker"
                key={`initialMarker`}
                longitude={initialMarkerLon}
                latitude={initialMarkerLat}
                color={'green'}
                onClick={(e) => {
                  e.originalEvent.stopPropagation()
                  defaultClickEvent({
                    lngLat: e.target._lngLat,
                    type: 'contextmenu',
                  })
                }}
                ref={popupRef}
              />
            )}
            {loopnetOriginalData.length > 0 &&
              aoiVisibility['mls'] &&
              loopnetOriginalData.map((ln_prop) => (
                <Marker
                  id={ln_prop.id}
                  key={`${ln_prop.id}_${ln_prop.color}`}
                  longitude={ln_prop.latlon[1]}
                  latitude={ln_prop.latlon[0]}
                  color={ln_prop.color}
                  onClick={(e) => {
                    e.originalEvent.stopPropagation()
                    onMarkerClick(e, ln_prop)
                  }}
                  ref={popupRef}
                />
              ))}
          </Map>
        </MapProvider>
        <QueryFilterModel
          isOpen={isQueryFilterModalOpen}
          onClose={closeModal}
          onSubmitDone={(v) => {
            onQueryFilterSuccess(v)
          }}
        />
        {mapLoaded &&
          mapRef.current &&
          (visibility['rated_wd_mat_vw'] || visibility['rated_gsa_mat_vw']) && (
            <div
              style={{
                position: 'absolute',
                bottom: '70px', // Adjust as needed
                left: '20px', // Adjust as needed
                background: 'rgba(255, 255, 255, 0.8)', // Optional background for visibility
                padding: '10px',
                borderRadius: '5px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#26E675',
                    width: '20px',
                    height: '20px',
                    marginRight: '5px',
                  }}
                />
                <span>Rated</span>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#FF0A80',
                    width: '20px',
                    height: '20px',
                    marginRight: '5px',
                  }}
                />
                <span>Unrated</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    backgroundColor: '#D7D7D7',
                    width: '20px',
                    height: '20px',
                    marginRight: '5px',
                    border: '1px solid #ccc',
                  }}
                />
                <span>White Area</span>
              </div>
            </div>
          )}
        {mapLoaded &&
          mapRef.current &&
          initialParcels.length > 0 &&
          Object.keys(initialApnSource).length > 0 &&
          Object.keys(initialApnLayer).length > 0 &&
          Object.keys(initialApnOutlineLayer).length > 0 && (
            <InitialParcelCardView
              parcelData={initialParcels}
              handleInitialParcelSelection={handleInitialParcelSelection}
              queryApn={queryApn}
              initialApnSource={initialApnSource}
              clickedGeojson={clickedGeojson}
              removeInitialParcels={removeInitialParcels}
              setClickedGeojson={setClickedGeojson}
              setCurrentIndex={setCurrentIndex}
              currentIndex={currentIndex}
              setShowInitialRightClickPopup={setShowInitialRightClickPopup}
              setInitialMarker={setInitialMarker}
              initialParcelLayersData={initialParcelLayersData}
            />
          )}
        {showParcelPopup && isMobile && (
          <div
            className={`bg-white item-center overflow-y-auto z-10 sticky bottom-0`}
            style={{ minHeight: '400px', maxHeight: '70vh', width: '100vw' }}
          >
            <div id="card-header" className="modal-header">
              <p className="text-2xl font-bold mb-3 text-blue-900"></p>
              <div>
                <span
                  className="close-button"
                  onClick={() => {
                    setShowParcelPopup(false)
                  }}
                >
                  x
                </span>
              </div>
            </div>
            <ParcelCardView
              page={'/home'}
              id={popupParcel.id}
              onParcelDelete={() => onParcelDelete(popupParcel.id)}
              onRanchParcelDelete={() => {
                onRanchParcelDelete(
                  popupParcel.id,
                  popupParcel.feature.properties.ranch_id,
                  popupParcel.feature.properties.parcel_ref_id
                )
              }}
              onEdit={() => onEdit(popupParcel.id)}
              property={popupParcel}
              onPropertyClicked={onPropertyClicked}
              handlePropertyMouseOver={handlePropertyMouseOver}
              handlePropertyMouseOut={handlePropertyMouseOut}
              isLoopnetProperty={isLoopnetProperty}
              isDemoUser={isDemoUser}
              setLoading={setLoading}
            />
          </div>
        )}
        {!isMobile &&
          (window.innerWidth < 690 ? (
            <div
              ref={refBox}
              className={`bg-white resizable-box shadow-md hover:shadow-xl transition-shadow duration-150 item-center overflow-y-auto z-10 ${
                window.innerWidth >= 690 ? 'sticky right-0' : 'sticky bottom-0'
              }`}
              style={propertyWidthStyle}
            >
              <div ref={refTop} className="resizer rt" onClick={() => {}}>
                <svg className="Icon" viewBox="0 0 24 24">
                  <path
                    fill="black"
                    d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                  />
                </svg>
              </div>

              <ul
                className={`grid ${
                  window.innerWidth >= 690 ? '' : 'mt-[10px]'
                }`}
              >
                {!isLoggedIn ? (
                  <div className="mt-10 text-center w-full content-center">
                    <div className="relative">
                      <button
                        onClick={() => {
                          navigate('/profile')
                        }}
                        className="px-7 py-3 bg-blue-600 text-white font-medium text-sm uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg w-[70%] text-center transition duration-150 ease-in-out "
                      >
                        Sign In
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <Collapsible trigger="Legend">
                      <div>Hydra Score</div>
                      <img
                        src={legendImage}
                        width={200}
                        title="Areas with an 'Excellent' rating may have abundant ground and surface water, with potentially no restrictions planned, or such minimal restrictions that farmers can easily meet current crop demands.&#013;&#013;Areas receiving a 'Good' rating may have a reliable supply of ground and/or surface water, with minor restrictions that do not significantly impede agricultural productivity or crop water requirements.&#013;&#013;An 'Average' rating is given to areas where ground and/or surface water supplies could be adequate, but some restrictions may be necessary, potentially affecting certain high-water-demand crops.&#013;&#013;'Marginal' areas may struggle with their ground and/or surface water resources, facing restrictions that can make it difficult for farmers to achieve optimal crop yields without careful water management.&#013;&#013;Areas with a 'Poor' rating could face a critical shortage of ground and surface water, resulting in severe restrictions that severely limit farming operations and crop production.&#013;&#013;Areas 'Not yet rated' have not been evaluated, and thus there is no information on whether their ground and surface water supplies can sustain current and planned agricultural uses."
                      />
                    </Collapsible>
                    <Collapsible
                      trigger={
                        <div className="CustomTrigger relative flex items-center space-x-1 ">
                          {'Your Ranches'}
                          <span
                            title="Remove all queried parcels from the list"
                            className={`absolute right-3 ${
                              Object.keys(selectedRanch).length === 0
                                ? 'cursor-not-allowed'
                                : 'cursor-pointer'
                            } text-sm`}
                            onClick={(event) => {
                              event.stopPropagation()
                              clearRanchSelection()
                            }}
                          >
                            Clear
                          </span>
                        </div>
                      }
                    >
                      <RanchSelector
                        ranches={ranches}
                        onRanchDropdownChange={onRanchDropdownChange}
                        selectedRanch={selectedRanch}
                      />
                      {/* <div style={{height: "200px", minWidth: "400px"}}>
                                                    <Dropdown options={ranches.map(ranch => ranch.ranch_name)} onChange={onRanchDropdownChange} placeholder="Select your ranch" value={selectedRanch.ranch_name} />
                                                </div> */}
                    </Collapsible>
                    {parcels.map((parcel) => parcel.id).length !== 0 && (
                      <Collapsible
                        open={true}
                        trigger={
                          <div className="CustomTrigger relative flex items-center space-x-1 ">
                            {'Queried Parcel(s)'}
                            <div className="flex flex-row flex-1 justify-end pr-16">
                              <LockToolTipIcon
                                className=" w-fit min-h-4 bg-transparent"
                                show={!enableCustomRanches}
                              />
                              <p
                                title="Remove all queried parcels from the list"
                                className={`
                                  
                                  ${
                                    parcels.map((parcel) => parcel.id)
                                      .length === 0 || !enableCustomRanches
                                      ? 'cursor-not-allowed'
                                      : 'cursor-pointer'
                                  } text-sm`}
                                disabled={!enableCustomRanches}
                                onClick={(event) => {
                                  if (!enableCustomRanches) {
                                    event.stopPropagation()
                                    return
                                  }
                                  event.stopPropagation()
                                  onEditAll()
                                }}
                              >
                                Add to Ranch
                              </p>
                            </div>
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-3 ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                onParcelDeleteAll()
                              }}
                            >
                              Clear
                            </span>
                          </div>
                        }
                        // trigger={"Queried Parcel(s)"}
                      >
                        {parcels.length ? (
                          parcels.map((parcel) => (
                            <div key={parcel.id}>
                              <ParcelCardView
                                page={'/home'}
                                id={parcel.id}
                                onParcelDelete={() => onParcelDelete(parcel.id)}
                                onRanchParcelDelete={() => {}}
                                onEdit={() => onEdit(parcel.id)}
                                property={parcel}
                                onPropertyClicked={onPropertyClicked}
                                handlePropertyMouseOver={
                                  handlePropertyMouseOver
                                }
                                handlePropertyMouseOut={handlePropertyMouseOut}
                                isDemoUser={isDemoUser}
                                setLoading={setLoading}
                                setPopupContent={setPopupContent}
                              />
                            </div>
                          ))
                        ) : (
                          <strong className="ml-5 mt-5 mr-5">
                            No Parcels queried
                          </strong>
                        )}
                      </Collapsible>
                    )}
                  </div>
                )}
              </ul>
            </div>
          ) : (
            <div
              className={`collapsible-menu rounded-md bg-white resizable-box shadow-md hover:shadow-xl transition-shadow duration-150 item-center overflow-y-auto z-10`}
            >
              <ul className={`grid`}>
                {
                  <div>
                    <Collapsible id="legend-collapsible" trigger="Legend">
                      <strong>Hydra Score</strong>
                      <div style={{ position: 'relative' }}>
                        <img src={legendImage} width={200} />
                        <button
                          style={{
                            height: '20px',
                            width: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            border: '1px solid #00ac9c',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            transition:
                              'box-shadow 0.3s ease, transform 0.3s ease',
                            position: 'absolute',
                            top: '8px', // Adjust to fit the top of the parent
                            right: '8px', // Adjust to fit the right corner of the parent
                          }}
                          onClick={() =>
                            setPopupContent(`An <strong style="color: #008000">Excellent</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 4 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #8fb935">Good</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 3 acre-feet (AF) per acre.\n
                                                    An <strong style="color: #e6e22e">Average</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand between 2-3 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #e09c3b">Marginal</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 2 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #e64747">Poor</strong> Hydra Score™ indicates that on an average annual basis, this land cannot reasonably be expected to sustain a crop with a water demand greater than 1.5 acre-feet (AF) per acre.\n
                                                    Areas marked as <strong style="color: #808080">“Not Yet Rated"</strong> indicates a region outside the current scope of the platform.\n
                                                    If you have a specific area that you would like scored, please reach out to our sales team at <a style="color: #0000EE" href="mailto:sales@hydrascore.com">sales@hydrascore.com</a>.`)
                          }
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 4px 10px rgba(0, 0, 0, 0.3)')
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 2px 5px rgba(0, 0, 0, 0.2)')
                          }
                        >
                          <FaCircleInfo color="#00ac9c" />
                        </button>
                      </div>
                      <strong>Soil Score</strong>
                      <div style={{ position: 'relative' }}>
                        <img src={legendImage} width={200} />
                        <button
                          style={{
                            height: '20px',
                            width: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            border: '1px solid #00ac9c',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            transition:
                              'box-shadow 0.3s ease, transform 0.3s ease',
                            position: 'absolute',
                            top: '8px', // Adjust to fit the top of the parent
                            right: '8px', // Adjust to fit the right corner of the parent
                          }}
                          onClick={() =>
                            setPopupContent(`The Soil Score, developed by the Hydra score team, is a comprehensive metric that integrates multiple factors, both empirical and subjective, to evaluate proximity to ideal conditions.\n
                                                    Areas with an <strong style="color: #008000">Excellent</strong> Soil Score exhibit optimal chemical/physical/hydrologic characteristics that support a wide range of field crops without any significant management issues.\n
                                                    Areas receiving a <strong style="color: #8fb935">Good</strong> Soil Score exhibit soil conditions that generally meet crop needs with minor adjustments needed, supported by favorable conditions, allowing for stable agricultural productivity.\n
                                                    An <strong style="color: #e6e22e">Average</strong> Soil Score is assigned to areas where soils adequately meet crop requirements but may exhibit some challenges such as less than ideal water percolation or retention, requiring moderate soil and water management strategies.\n
                                                    Areas rated as <strong style="color: #e09c3b">Marginal</strong> face challenges with more pronounced issues like limited deep percolation or higher salinity, impacting water quality and distribution, thus necessitating careful management to optimize crop yield and health.\n
                                                    Areas with a <strong style="color: #e64747">Poor</strong> Soil Score are significantly hindered by inadequate chemical/physical/hydrologic characteristics, which indicate potentially serious problems, severely limiting agricultural capabilities and crop diversity.\n
                                                    Areas marked as <strong style="color: #808080">“Not Yet Rated"</strong> have not been assessed for their chemical/physical/hydrologic characteristics, leaving uncertainties about their suitability for agriculture based on soil and water management criteria.`)
                          }
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 4px 10px rgba(0, 0, 0, 0.3)')
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 2px 5px rgba(0, 0, 0, 0.2)')
                          }
                        >
                          <FaCircleInfo color="#00ac9c" />
                        </button>
                      </div>
                    </Collapsible>
                    <Collapsible
                      triggerDisabled={!enableCustomRanches}
                      trigger={
                        <div
                          className={cn(
                            'CustomTrigger relative flex items-center space-x-1 ',
                            enableCustomRanches
                              ? 'cursor-pointer'
                              : 'cursor-not-allowed'
                          )}
                        >
                          <div className="flex">
                            <LockToolTipIcon
                              className=" w-fit min-h-4 bg-transparent"
                              show={!enableCustomRanches}
                            />
                            <p>{'Your Ranches'}</p>
                          </div>
                          <span
                            title="Clear selected ranch"
                            className={`absolute right-3 ${
                              Object.keys(selectedRanch).length === 0
                                ? 'cursor-not-allowed'
                                : 'cursor-pointer'
                            } text-sm`}
                            onClick={(event) => {
                              clearRanchSelection()
                            }}
                          >
                            Clear
                          </span>
                        </div>
                      }
                    >
                      <RanchSelector
                        ranches={ranches}
                        onRanchDropdownChange={onRanchDropdownChange}
                        selectedRanch={selectedRanch}
                      />
                      {/* <div id="ranchDropdown" style={{height: "200px", minWidth: "400px"}}>
                                                <Dropdown options={ranches.map(ranch => ranch.ranch_name)} onChange={onRanchDropdownChange} placeholder="Select your ranch" value={selectedRanch.ranch_name}/>
                                            </div> */}
                    </Collapsible>
                    {parcels.map((parcel) => parcel.id).length !== 0 && (
                      <Collapsible
                        open={true}
                        trigger={
                          <div className="CustomTrigger relative flex items-center space-x-1 truncate">
                            <p>{'Queried Parcel(s)'}</p>
                            <div className="flex flex-row flex-1 justify-end pr-16">
                              <LockToolTipIcon
                                className=" w-fit min-h-4 bg-transparent"
                                show={!enableCustomRanches}
                              />
                              <p
                                title="Remove all queried parcels from the list"
                                className={`
                                  
                                  ${
                                    parcels.map((parcel) => parcel.id)
                                      .length === 0 || !enableCustomRanches
                                      ? 'cursor-not-allowed'
                                      : 'cursor-pointer'
                                  } t`}
                                disabled={!enableCustomRanches}
                                onClick={(event) => {
                                  if (!enableCustomRanches) {
                                    event.stopPropagation()
                                    return
                                  }
                                  event.stopPropagation()
                                  onEditAll()
                                }}
                              >
                                Add to Ranch
                              </p>
                            </div>
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-3 ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                onParcelDeleteAll()
                              }}
                            >
                              Clear
                            </span>
                          </div>
                        }
                        // trigger={"Queried Parcel(s)"}
                      >
                        {parcels.length ? (
                          parcels.map((parcel) => (
                            <div key={parcel.id}>
                              <ParcelCardView
                                page={'/home'}
                                id={parcel.id}
                                onParcelDelete={() => onParcelDelete(parcel.id)}
                                onRanchParcelDelete={() => {}}
                                onEdit={() => onEdit(parcel.id)}
                                property={parcel}
                                onPropertyClicked={onPropertyClicked}
                                handlePropertyMouseOver={
                                  handlePropertyMouseOver
                                }
                                handlePropertyMouseOut={handlePropertyMouseOut}
                                isDemoUser={isDemoUser}
                                setLoading={setLoading}
                                setPopupContent={setPopupContent}
                              />
                            </div>
                          ))
                        ) : (
                          <strong className="ml-5 mt-5 mr-5">
                            No Parcels queried
                          </strong>
                        )}
                      </Collapsible>
                    )}
                  </div>
                }
              </ul>
            </div>
          ))}
        <AdvanceFilters
          isOpenFilterCriteria={isQueryFilterModalOpen}
          onSubmitDone={onQueryFilterSuccess}
          onClear={() => {
            setVisibility({
              ...visibility,
              ['filtered_parcels']: false,
            })
            deleteGeoJson()
            setInitialMarker(false)
            setInitialParcels([])
            setInitialApnSource({})
            setInitialApnLayer({})
            setInitialApnOutlineLayer({})
          }}
        />
        <TrialModal setJoyrideRun={setJoyrideRun} />
      </div>
    </>
  )
}
